{
  "about.blocks": "Servidores moderados",
  "about.contact": "Contacto:",
  "about.default_locale": "Predeterminado",
  "about.disclaimer": "Mastodon es software libre y de código abierto y una marca comercial de Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Motivo no disponible",
  "about.domain_blocks.preamble": "Mastodon normalmente te permite ver el contenido e interactuar con los usuarios de cualquier otro servidor en el fediverso. Estas son las excepciones que se han hecho en este servidor en particular.",
  "about.domain_blocks.silenced.explanation": "Normalmente no verás perfiles y contenido de este servidor, a menos que lo busqués explícitamente o sigás alguna cuenta.",
  "about.domain_blocks.silenced.title": "Limitados",
  "about.domain_blocks.suspended.explanation": "Ningún dato de este servidor será procesado, almacenado o intercambiado, haciendo imposible cualquier interacción o comunicación con los usuarios de este servidor.",
  "about.domain_blocks.suspended.title": "Suspendidos",
  "about.language_label": "Idioma",
  "about.not_available": "Esta información no está disponible en este servidor.",
  "about.powered_by": "Redes sociales descentralizadas con tecnología de {mastodon}",
  "about.rules": "Reglas del servidor",
  "account.account_note_header": "Nota personal",
  "account.activity": "Actividad",
  "account.add_note": "Agregar una nota personal",
  "account.add_or_remove_from_list": "Agregar o quitar de las listas",
  "account.badges.admin": "Administración",
  "account.badges.blocked": "Cuenta bloqueada",
  "account.badges.bot": "Automatizada",
  "account.badges.domain_blocked": "Dominio bloqueado",
  "account.badges.group": "Grupo",
  "account.badges.muted": "Cuenta silenciada",
  "account.badges.muted_until": "Cuenta silenciada hasta {until}",
  "account.block": "Bloquear a @{name}",
  "account.block_domain": "Bloquear dominio {domain}",
  "account.block_short": "Bloquear",
  "account.blocked": "Bloqueado",
  "account.cancel_follow_request": "Dejar de seguir",
  "account.copy": "Copiar enlace al perfil",
  "account.direct": "Mención privada a @{name}",
  "account.disable_notifications": "Dejar de notificarme cuando @{name} envíe mensajes",
  "account.edit_note": "Editar nota personal",
  "account.edit_profile": "Editar perfil",
  "account.edit_profile_short": "Editar",
  "account.enable_notifications": "Notificarme cuando @{name} envíe mensajes",
  "account.endorse": "Destacar en el perfil",
  "account.familiar_followers_many": "Seguido por {name1}, {name2} y {othersCount, plural, one {# cuenta más que conocés} other {# cuentas más que conocés}}",
  "account.familiar_followers_one": "Seguido por {name1}",
  "account.familiar_followers_two": "Seguido por {name1} y {name2}",
  "account.featured": "Destacados",
  "account.featured.accounts": "Perfiles",
  "account.featured.collections": "Colecciones",
  "account.featured.new_collection": "Nueva colección",
  "account.field_overflow": "Mostrar contenido completo",
  "account.filters.all": "Toda la actividad",
  "account.filters.boosts_toggle": "Mostrar adhesiones",
  "account.filters.posts_boosts": "Mensajes y adhesiones",
  "account.filters.posts_only": "Mensajes",
  "account.filters.posts_replies": "Mensajes y respuestas",
  "account.filters.replies_toggle": "Mostrar respuestas",
  "account.follow": "Seguir",
  "account.follow_back": "Seguir",
  "account.follow_back_short": "Seguir",
  "account.follow_request": "Solicitud para seguir",
  "account.follow_request_cancel": "Cancelar solicitud",
  "account.follow_request_cancel_short": "Cancelar",
  "account.follow_request_short": "Solicitar",
  "account.followers": "Seguidores",
  "account.followers.empty": "Todavía nadie sigue a este usuario.",
  "account.followers_counter": "{count, plural, one {{counter} seguidor} other {{counter} seguidores}}",
  "account.followers_you_know_counter": "{counter} seguidores que conocés",
  "account.following": "Siguiendo",
  "account.following_counter": "{count, plural, one {siguiendo a {counter}} other {siguiendo a {counter}}}",
  "account.follows.empty": "Todavía este usuario no sigue a nadie.",
  "account.follows_you": "Te sigue",
  "account.go_to_profile": "Ir al perfil",
  "account.hide_reblogs": "Ocultar adhesiones de @{name}",
  "account.in_memoriam": "Cuenta conmemorativa.",
  "account.join_modal.day": "Día",
  "account.join_modal.me": "Te uniste a {server} el",
  "account.join_modal.me_anniversary": "¡Feliz Fediversario! Te uniste a {server} el",
  "account.join_modal.me_today": "¡Es tu primer día en {server}!",
  "account.join_modal.other": "{name} se unió a {server} el",
  "account.join_modal.other_today": "¡Es el primer día de {name} en {server}!",
  "account.join_modal.share.celebrate": "Compartí un mensaje conmemorativo",
  "account.join_modal.share.intro": "Compartí un mensaje introductorio",
  "account.join_modal.share.welcome": "Compartí un mensaje de bienvenida",
  "account.join_modal.years": "{number, plural, one {# año} other {# años}}",
  "account.joined_short": "En este servidor desde",
  "account.languages": "Cambiar idiomas suscritos",
  "account.last_active": "Última actividad",
  "account.link_verified_on": "La propiedad de este enlace fue verificada el {date}",
  "account.locked_info": "Esta cuenta es privada. El propietario manualmente revisa quién puede seguirle.",
  "account.media": "Medios",
  "account.mention": "Mencionar a @{name}",
  "account.menu.add_to_list": "Añadir a lista…",
  "account.menu.block": "Bloquear cuenta",
  "account.menu.block_domain": "Bloquear a {domain}",
  "account.menu.copied": "Enlace de cuenta copiado al portapapeles",
  "account.menu.copy": "Copiar enlace",
  "account.menu.direct": "Mención privada",
  "account.menu.hide_reblogs": "Ocultar adhesiones en la línea temporal",
  "account.menu.mention": "Mención",
  "account.menu.mute": "Silenciar cuenta",
  "account.menu.note.description": "Visible solo para vos",
  "account.menu.open_original_page": "Ver en {domain}",
  "account.menu.remove_follower": "Quitar seguidor",
  "account.menu.report": "Denunciar cuenta",
  "account.menu.share": "Compartir…",
  "account.menu.show_reblogs": "Mostrar adhesiones en la línea temporal",
  "account.menu.unblock": "Desbloquear cuenta",
  "account.menu.unblock_domain": "Desbloquear a {domain}",
  "account.menu.unmute": "Dejar de silenciar cuenta",
  "account.moved_to": "{name} indicó que su nueva cuenta ahora es:",
  "account.mute": "Silenciar a @{name}",
  "account.mute_notifications_short": "Silenciar notificaciones",
  "account.mute_short": "Silenciar",
  "account.muted": "Silenciado",
  "account.mutual": "Se siguen mutuamente",
  "account.name.copy": "Copiar alias",
  "account.name.help.domain": "«{domain}» es el servidor que hospeda el perfil y los mensajes del usuario.",
  "account.name.help.domain_self": "«{domain}» es tu servidor que hospeda tu perfil y tus mensajes.",
  "account.name.help.footer": "Al igual que podés enviar correos electrónicos a personas usando diferentes proveedores de correo electrónico, del mismo modo podés interactuar con personas en otros servidores de Mastodon y en otras redes sociales compatibles con el Fediverso.",
  "account.name.help.header": "Un alias es similar a una dirección de correo electrónico",
  "account.name.help.username": "«{username}» es el nombre de usuario de esta cuenta en su servidor. Alguien en otro servidor puede tener el mismo nombre de usuario.",
  "account.name.help.username_self": "«{username}» es tu nombre de usuario en este servidor. Alguien en otro servidor puede tener el mismo nombre de usuario.",
  "account.name_info": "¿Qué significa?",
  "account.no_bio": "Sin descripción provista.",
  "account.node_modal.callout": "Las notas personales son visibles solo para vos.",
  "account.node_modal.edit_title": "Editar nota personal",
  "account.node_modal.error_unknown": "No se pudo guardar la nota",
  "account.node_modal.field_label": "Nota personal",
  "account.node_modal.save": "Guardar",
  "account.node_modal.title": "Agregar una nota personal",
  "account.note.edit_button": "Editar",
  "account.note.title": "Nota personal (visible solo para vos)",
  "account.open_original_page": "Abrir página original",
  "account.pending": "Pendiente",
  "account.posts": "Mensajes",
  "account.remove_from_followers": "Quitar a {name} de tus seguidores",
  "account.report": "Denunciar a @{name}",
  "account.requested_follow": "{name} solicitó seguirte",
  "account.share": "Compartir el perfil de @{name}",
  "account.show_reblogs": "Mostrar adhesiones de @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} mensaje} other {{counter} mensajes}}",
  "account.timeline.pinned": "Mensaje fijado",
  "account.timeline.pinned.view_all": "Ver todos los mensajes fijados",
  "account.unblock": "Desbloquear a @{name}",
  "account.unblock_domain": "Desbloquear dominio {domain}",
  "account.unblock_domain_short": "Desbloquear",
  "account.unblock_short": "Desbloquear",
  "account.unendorse": "No destacar en el perfil",
  "account.unfollow": "Dejar de seguir",
  "account.unmute": "Dejar de silenciar a @{name}",
  "account.unmute_notifications_short": "Dejar de silenciar notificaciones",
  "account.unmute_short": "Dejar de silenciar",
  "account_edit.advanced_settings.bot_hint": "Señala a otras cuentas que esta cuenta principalmente realiza acciones automatizadas y podría no estar monitoreada",
  "account_edit.advanced_settings.bot_label": "Cuenta automatizada",
  "account_edit.advanced_settings.title": "Configuración avanzada",
  "account_edit.bio.add_label": "Agregar biografía",
  "account_edit.bio.edit_label": "Editar biografía",
  "account_edit.bio.placeholder": "Agregá una breve introducción para ayudar a otras personas a identificarte.",
  "account_edit.bio.title": "Biografía",
  "account_edit.bio_modal.add_title": "Agregar biografía",
  "account_edit.bio_modal.edit_title": "Editar biografía",
  "account_edit.column_button": "Listo",
  "account_edit.column_title": "Editar perfil",
  "account_edit.custom_fields.add_label": "Agregar campo",
  "account_edit.custom_fields.edit_label": "Editar campo",
  "account_edit.custom_fields.placeholder": "Agregá tus pronombres personales, enlaces externos o cualquier otra cosa que quisieras compartir.",
  "account_edit.custom_fields.reorder_button": "Reordenar campos",
  "account_edit.custom_fields.tip_content": "Podés agregar fácilmente credibilidad a tu cuenta de Mastodon verificando enlaces a cualquier sitio web que tengas.",
  "account_edit.custom_fields.tip_title": "Consejo: Agregá enlaces verificados",
  "account_edit.custom_fields.title": "Campos personalizados",
  "account_edit.custom_fields.verified_hint": "¿Cómo agrego un enlace verificado?",
  "account_edit.display_name.add_label": "Agregar nombre a mostrar",
  "account_edit.display_name.edit_label": "Editar nombre a mostrar",
  "account_edit.display_name.placeholder": "Tu nombre a mostrar es cómo aparecerá tu nombre en tu perfil y en las líneas temporales.",
  "account_edit.display_name.title": "Nombre a mostrar",
  "account_edit.featured_hashtags.edit_label": "Agregar etiquetas",
  "account_edit.featured_hashtags.placeholder": "Ayudá a otras personas a identificarte y a tener un rápido acceso a tus temas favoritos.",
  "account_edit.featured_hashtags.title": "Etiquetas destacadas",
  "account_edit.field_actions.delete": "Eliminar campo",
  "account_edit.field_actions.edit": "Editar campo",
  "account_edit.field_delete_modal.confirm": "¿De verdad querés eliminar este campo personalizado? Esta acción no se puede deshacer.",
  "account_edit.field_delete_modal.delete_button": "Eliminar",
  "account_edit.field_delete_modal.title": "¿Eliminar campo personalizado?",
  "account_edit.field_edit_modal.add_title": "Agregar campo personalizado",
  "account_edit.field_edit_modal.discard_confirm": "Descartar",
  "account_edit.field_edit_modal.discard_message": "Tenés cambios sin guardar. ¿De verdad querés descartarlos?",
  "account_edit.field_edit_modal.edit_title": "Editar campo personalizado",
  "account_edit.field_edit_modal.length_warning": "Se excedió el límite recomendado de caracteres. Es posible que los usuarios en dispositivos móviles no vean tu campo completo.",
  "account_edit.field_edit_modal.link_emoji_warning": "No recomendamos el uso de emojis personalizados en combinación con direcciones web. Los campos personalizados que contengan ambos solo se mostrarán como texto en lugar de como enlace, con el fin de evitar la confusión del usuario.",
  "account_edit.field_edit_modal.name_hint": "Por ejemplo: «Sitio web personal»",
  "account_edit.field_edit_modal.name_label": "Etiqueta",
  "account_edit.field_edit_modal.url_warning": "Para agregar un enlace, por favor, incluí {protocol} al comienzo.",
  "account_edit.field_edit_modal.value_hint": "Por ejemplo: «https://ejemplo.com»",
  "account_edit.field_edit_modal.value_label": "Valor",
  "account_edit.field_reorder_modal.drag_cancel": "El arrastre fue cancelado. Se soltó el campo «{item}».",
  "account_edit.field_reorder_modal.drag_end": "Se soltó el campo «{item}».",
  "account_edit.field_reorder_modal.drag_instructions": "Para reordenar campos personalizados, pulsá la tecla «Espacio» o «Intro ⏎». Mientras arrastrás, usá las teclas de flecha para mover el campo hacia arriba o hacia abajo. Presioná la tecla «Espacio» o «Intro ⏎» de nuevo para soltar el campo en su nueva posición, o presioná la tecla «Escape» para cancelar.",
  "account_edit.field_reorder_modal.drag_move": "El campo «{item}» fue movido.",
  "account_edit.field_reorder_modal.drag_over": "El campo «{item}» fue movido sobre «{over}».",
  "account_edit.field_reorder_modal.drag_start": "Campo elegido «{item}».",
  "account_edit.field_reorder_modal.handle_label": "Arrastrá el campo «{item}»",
  "account_edit.field_reorder_modal.title": "Reordená los campos",
  "account_edit.image_alt_modal.add_title": "Agregar texto alternativo",
  "account_edit.image_alt_modal.details_content": "LO QUE VA: <ul> <li>Describite como se te ve en la imagen</li> <li>Usá un idioma en tercera persona (por ejemplo: decí «Oliver», en lugar de, simplemente, «yo»)</li> <li>Sé breve: unas pocas palabras son suficientes</li> </ul> EVITÁ: <ul> <li>Comenzar con «Foto de…»: es redundante para lectores de pantalla</li> </ul> EJEMPLO DE UNA BUENA DESCRIPCIÓN: <ul> <li>«Oliver abrazando a su gato Dulce»</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Consejos: Texto alternativo para imágenes de perfil",
  "account_edit.image_alt_modal.edit_title": "Editar texto alternativo",
  "account_edit.image_alt_modal.text_hint": "El texto alternativo ayuda a los usuarios de lectores de pantalla a entender tu contenido.",
  "account_edit.image_alt_modal.text_label": "Texto alternativo",
  "account_edit.image_delete_modal.confirm": "¿De verdad querés eliminar esta imagen? Esta acción no se puede deshacer.",
  "account_edit.image_delete_modal.delete_button": "Eliminar",
  "account_edit.image_delete_modal.title": "¿Eliminar imagen?",
  "account_edit.image_edit.add_button": "Agregar imagen",
  "account_edit.image_edit.alt_add_button": "Agregar texto alternativo",
  "account_edit.image_edit.alt_edit_button": "Editar texto alternativo",
  "account_edit.image_edit.remove_button": "Quitar imagen",
  "account_edit.image_edit.replace_button": "Reemplazar imagen",
  "account_edit.item_list.delete": "Eliminar {name}",
  "account_edit.item_list.edit": "Editar {name}",
  "account_edit.name_modal.add_title": "Agregar nombre a mostrar",
  "account_edit.name_modal.edit_title": "Editar nombre a mostrar",
  "account_edit.profile_tab.button_label": "Personalizar",
  "account_edit.profile_tab.hint.description": "Esta configuración personaliza lo que los usuarios ven en {server} en las aplicaciones oficiales, pero es posible que no se apliquen a los usuarios en otros servidores y aplicaciones de terceros.",
  "account_edit.profile_tab.hint.title": "Las pantallas pueden variar",
  "account_edit.profile_tab.show_featured.description": "«Destacados» es una pestaña opcional en donde podés mostrar otras cuentas.",
  "account_edit.profile_tab.show_featured.title": "Mostrar pestaña «Destacados»",
  "account_edit.profile_tab.show_media.description": "«Medios» es una pestaña opcional que muestra tus mensajes conteniendo imágenes, videos o audios.",
  "account_edit.profile_tab.show_media.title": "Mostrar pestaña «Medios»",
  "account_edit.profile_tab.show_media_replies.description": "Cuando está habilitada, la pestaña «Medios» muestra tanto tus mensajes como tus respuestas a otras cuentas.",
  "account_edit.profile_tab.show_media_replies.title": "Incluir respuestas en la pestaña «Medios»",
  "account_edit.profile_tab.show_relations.description": "Muestra cuentas que seguís y seguidores de otros usuarios en tu perfil. Las otras cuentas siempre podrán saber si las seguís.",
  "account_edit.profile_tab.show_relations.title": "Mostrar «Seguidores» y «Siguiendo»",
  "account_edit.profile_tab.subtitle": "Personalizá cómo se muestra tu perfil.",
  "account_edit.profile_tab.title": "Configuración de visualización de perfil",
  "account_edit.save": "Guardar",
  "account_edit.upload_modal.back": "Volver",
  "account_edit.upload_modal.done": "Listo",
  "account_edit.upload_modal.next": "Siguiente",
  "account_edit.upload_modal.step_crop.zoom": "Zoom",
  "account_edit.upload_modal.step_upload.button": "Explorar archivos",
  "account_edit.upload_modal.step_upload.dragging": "Arrastrá para subir",
  "account_edit.upload_modal.step_upload.header": "Elegí una imagen",
  "account_edit.upload_modal.step_upload.hint": "Formato WEBP, PNG, GIF o JPG, hasta {limit} MB.{br}La imagen será escalada a {width}x{height} píxeles.",
  "account_edit.upload_modal.title_add.avatar": "Agregar imagen de perfil",
  "account_edit.upload_modal.title_add.header": "Agregar imagen de cubierta",
  "account_edit.upload_modal.title_replace.avatar": "Reemplazar imagen de perfil",
  "account_edit.upload_modal.title_replace.header": "Reemplazar imagen de cubierta",
  "account_edit.verified_modal.details": "Agregá credibilidad a tu perfil de Mastodon verificando enlaces a sitios web personales. Así es cómo funciona:",
  "account_edit.verified_modal.invisible_link.details": "Agregá el enlace a tu encabezado. La parte importante es rel=\"yo\" que evita la suplantación en sitios web con contenido generado por el usuario. Incluso podés usar una etiqueta de enlace en el encabezado de la página en lugar de {tag}, pero el código HTML debe ser accesible sin ejecutar JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "¿Cómo hago el enlace invisible?",
  "account_edit.verified_modal.step1.header": "Copiá el código HTML de abajo y pegalo en el encabezado de tu sitio web",
  "account_edit.verified_modal.step2.details": "Si ya agregaste tu sitio web como un campo personalizado, vas a necesitar eliminarlo y volver a agregarlo para activar la verificación.",
  "account_edit.verified_modal.step2.header": "Agregá tu sitio web como un campo personalizado",
  "account_edit.verified_modal.title": "¿Cómo agregar un enlace verificado?",
  "account_edit_tags.add_tag": "Agregar #{tagName}",
  "account_edit_tags.column_title": "Editar etiquetas",
  "account_edit_tags.help_text": "Las etiquetas destacadas ayudan a los usuarios a descubrir e interactuar con tu perfil. Las etiquetas destacadas aparecen como filtros en la vista de actividad de la página de tu perfil.",
  "account_edit_tags.max_tags_reached": "Alcanzaste el número máximo de etiquetas destacadas.",
  "account_edit_tags.search_placeholder": "Ingresá una etiqueta…",
  "account_edit_tags.suggestions": "Sugerencias:",
  "account_edit_tags.tag_status_count": "{count, plural, one {voto} other {votos}}",
  "account_list.hidden_notice": "Esto solo es visible para vos. Para mostrar esta lista a otros usuarios, andá a <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# hora} other {# horas}}",
  "account_note.placeholder": "Hacé clic par agregar una nota",
  "admin.dashboard.daily_retention": "Tasa de retención de usuarios por día, después del registro",
  "admin.dashboard.monthly_retention": "Tasa de retención de usuarios por mes, después del registro",
  "admin.dashboard.retention.average": "Promedio",
  "admin.dashboard.retention.cohort": "Mes de registro",
  "admin.dashboard.retention.cohort_size": "Nuevos usuarios",
  "admin.impact_report.instance_accounts": "Cuentas que se eliminarían",
  "admin.impact_report.instance_followers": "Seguidores que nuestros usuarios perderían",
  "admin.impact_report.instance_follows": "Seguidores que perderían sus usuarios",
  "admin.impact_report.title": "Resumen de impacto",
  "alert.rate_limited.message": "Por favor, reintentá después de las {retry_time, time, medium}.",
  "alert.rate_limited.title": "Acción limitada",
  "alert.unexpected.message": "Ocurrió un error.",
  "alert.unexpected.title": "¡Epa!",
  "alt_text_badge.title": "Texto alternativo",
  "alt_text_modal.add_alt_text": "Agregar texto alternativo",
  "alt_text_modal.add_text_from_image": "Agregar texto a partir de la imagen",
  "alt_text_modal.cancel": "Cancelar",
  "alt_text_modal.change_thumbnail": "Cambiar miniatura",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Describí esto para personas con dificultades auditivas…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Describí esto para personas con dificultades visuales…",
  "alt_text_modal.done": "Listo",
  "announcement.announcement": "Anuncio",
  "annual_report.announcement.action_build": "Construir mi MastodonAnual",
  "annual_report.announcement.action_dismiss": "No, gracias",
  "annual_report.announcement.action_view": "Ver mi MastodonAnual",
  "annual_report.announcement.description": "Descubrí más sobre tu participación en Mastodon durante el último año.",
  "annual_report.announcement.title": "Llegó MastodonAnual {year}",
  "annual_report.nav_item.badge": "Nueva",
  "annual_report.shared_page.donate": "Donar",
  "annual_report.shared_page.footer": "Generado con {heart} por el equipo de Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} usa {domain}, una de las tantas comunidades de Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} permaneció al acecho en busca de mensajes para adherir, apuntando a otros creadores con perfecta puntería.",
  "annual_report.summary.archetype.booster.desc_self": "Permaneciste al acecho en busca de mensajes para adherir, apuntando a otros creadores con perfecta puntería.",
  "annual_report.summary.archetype.booster.name": "El arquero",
  "annual_report.summary.archetype.die_drei_fragezeichen": "¿¿¿???",
  "annual_report.summary.archetype.lurker.desc_public": "Sabemos que {name} estuvo afuera, en algún lado, disfrutando de Mastodon a su propio modo silencioso.",
  "annual_report.summary.archetype.lurker.desc_self": "Sabemos que estuviste afuera, en algún lado, disfrutando de Mastodon a tu propio modo silencioso.",
  "annual_report.summary.archetype.lurker.name": "El estoico",
  "annual_report.summary.archetype.oracle.desc_public": "{name} creó más mensajes nuevos que respuestas, manteniendo a Mastodon fresco y de cara al futuro.",
  "annual_report.summary.archetype.oracle.desc_self": "Creaste más mensajes nuevos que respuestas, manteniendo a Mastodon fresco y de cara al futuro.",
  "annual_report.summary.archetype.oracle.name": "El oráculo",
  "annual_report.summary.archetype.pollster.desc_public": "{name} creó más encuestas que mensajes de otro tipo, cultivando curiosidad en Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Creaste más encuestas que mensajes de otro tipo, cultivando curiosidad en Mastodon.",
  "annual_report.summary.archetype.pollster.name": "El maravillado",
  "annual_report.summary.archetype.replier.desc_public": "{name} respondió frecuentemente a los mensajes de otras cuentas, polinizando con nuevos debates.",
  "annual_report.summary.archetype.replier.desc_self": "Respondiste frecuentemente a los mensajes de otras cuentas, polinizando con nuevos debates.",
  "annual_report.summary.archetype.replier.name": "La mariposa",
  "annual_report.summary.archetype.reveal": "Revelar mi arquetipo",
  "annual_report.summary.archetype.reveal_description": "¡Gracias por ser parte de Mastodon! Es hora de descubrir qué arquetipo encarnaste en {year}.",
  "annual_report.summary.archetype.title_public": "El arquetipo de {name}",
  "annual_report.summary.archetype.title_self": "Tu arquetipo",
  "annual_report.summary.close": "Cerrar",
  "annual_report.summary.copy_link": "Copiar enlace",
  "annual_report.summary.followers.new_followers": "{count, plural, one {nuevo seguidor} other {nuevos seguidores}}",
  "annual_report.summary.highlighted_post.boost_count": "Este mensaje recibió adhesiones {count, plural, one {una vez} other {# veces}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Este mensaje fue marcado como favorito {count, plural, one {una vez} other {# veces}}.",
  "annual_report.summary.highlighted_post.reply_count": "Este mensaje recibió {count, plural, one {una respuesta} other {# respuestas}}.",
  "annual_report.summary.highlighted_post.title": "Mensaje más popular",
  "annual_report.summary.most_used_app.most_used_app": "la aplicación más usada",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "la etiqueta más usada",
  "annual_report.summary.most_used_hashtag.used_count": "Incluiste esta etiqueta en {count, plural, one {un mensaje} other {# mensajes}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} incluyó esta etiqueta en {count, plural, one {un mensaje} other {# mensajes}}.",
  "annual_report.summary.new_posts.new_posts": "nuevos mensajes",
  "annual_report.summary.percentile.text": "<topLabel>Eso te coloca en la cima del</topLabel><percentage></percentage><bottomLabel>de los usuarios de {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Queda entre nos.",
  "annual_report.summary.share_elsewhere": "Compartir en otro lado",
  "annual_report.summary.share_message": "¡Conseguí el arquetipo {archetype}!",
  "annual_report.summary.share_on_mastodon": "Compartir en Mastodon",
  "attachments_list.unprocessed": "[sin procesar]",
  "audio.hide": "Ocultar audio",
  "block_modal.no_collections": "Ninguno de ustedes pueden agregarse entre sí a las colecciones. Serás eliminado automáticamente de las colecciones existentes de los demás, si es aplicable.",
  "block_modal.remote_users_caveat": "Le pediremos al servidor {domain} que respete tu decisión. Sin embargo, el cumplimiento no está garantizado, ya que algunos servidores pueden manejar los bloqueos de forma diferente. Los mensajes públicos todavía podrían estar visibles para los usuarios no conectados.",
  "block_modal.show_less": "Mostrar menos",
  "block_modal.show_more": "Mostrar más",
  "block_modal.they_cant_mention": "No pueden mencionarse, seguirse ni citarse unos a otros.",
  "block_modal.they_cant_see_posts": "No pueden ver tus mensajes y vos no verás los suyos.",
  "block_modal.they_will_know": "Pueden ver que están bloqueados.",
  "block_modal.title": "¿Bloquear usuario?",
  "block_modal.you_wont_see_mentions": "No verás mensajes de otros que los mencionen.",
  "boost_modal.combo": "Podés hacer clic en {combo} para saltar esto la próxima vez",
  "boost_modal.reblog": "¿Adherir al mensaje?",
  "boost_modal.undo_reblog": "¿Dejar de adherir al mensaje?",
  "bundle_column_error.copy_stacktrace": "Copiar informe de error",
  "bundle_column_error.error.body": "La página solicitada no pudo ser cargada. Podría deberse a un error de programación en nuestro código o a un problema de compatibilidad con el navegador web.",
  "bundle_column_error.error.title": "¡Epa!",
  "bundle_column_error.network.body": "Se produjo un error al intentar cargar esta página. Esto puede deberse a un problema temporal con tu conexión a internet o a este servidor.",
  "bundle_column_error.network.title": "Error de red",
  "bundle_column_error.retry": "Intentá de nuevo",
  "bundle_column_error.return": "Volver al inicio",
  "bundle_column_error.routing.body": "No se pudo encontrar la página solicitada. ¿La dirección web es correcta?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Cerrar",
  "bundle_modal_error.message": "Algo salió mal al cargar esta pantalla.",
  "bundle_modal_error.retry": "Intentá de nuevo",
  "callout.dismiss": "Descartar",
  "carousel.current": "<sr>Diapositiva</sr> {current, number} / {max, number}",
  "carousel.slide": "Diapositiva {current, number} de {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} caracteres recomendados",
  "character_counter.required": "{currentLength}/{maxLength} caracteres",
  "closed_registrations.other_server_instructions": "Ya que Mastodon es descentralizado, podés crearte una cuenta en otro servidor y todavía interactuar con éste.",
  "closed_registrations_modal.description": "Actualmente no es posible crearte una cuenta en {domain}. pero recordá que no necesitás tener una cuenta puntualmente dentro de {domain} para poder usar Mastodon.",
  "closed_registrations_modal.find_another_server": "Buscar otro servidor",
  "closed_registrations_modal.preamble": "Mastodon es descentralizado, por lo que no importa dónde creés tu cuenta, podrás seguir e interactuar con cualquier persona en este servidor. ¡Incluso podés montar tu propio servidor!",
  "closed_registrations_modal.title": "Registrarse en Mastodon",
  "collection.share_modal.share_link_label": "Compartir enlace",
  "collection.share_modal.share_via_post": "Enviar a Mastodon",
  "collection.share_modal.share_via_system": "Compartir en…",
  "collection.share_modal.title": "Compartir colección",
  "collection.share_modal.title_new": "¡Compartí tu nueva colección!",
  "collection.share_template_other": "¡Mirá qué copada está esta colección! {link}",
  "collection.share_template_own": "Mirá mi nueva colección: {link}",
  "collections.account_count": "{count, plural, one {# hora} other {# horas}}",
  "collections.accounts.empty_description": "Agregá hasta {count} cuentas",
  "collections.accounts.empty_editor_title": "Todavía no hay nadie en esta colección",
  "collections.accounts.empty_title": "Esta colección está vacía",
  "collections.block_collection_owner": "Bloquear cuenta",
  "collections.by_account": "por {account_handle}",
  "collections.collection_description": "Descripción",
  "collections.collection_language": "Idioma",
  "collections.collection_language_none": "Ninguno",
  "collections.collection_name": "Nombre",
  "collections.collection_topic": "Tema",
  "collections.confirm_account_removal": "¿De verdad querés eliminar esta cuenta de esta colección?",
  "collections.content_warning": "Advertencia de contenido",
  "collections.continue": "Continuar",
  "collections.copy_link": "Copiar enlace",
  "collections.copy_link_confirmation": "Enlace a la colección copiado al portapapeles",
  "collections.create.accounts_title": "¿A quién vas a destacar en esta colección?",
  "collections.create.basic_details_title": "Detalles básicos",
  "collections.create.steps": "Paso {step}/{total}",
  "collections.create_collection": "Crear colección",
  "collections.delete_collection": "Eliminar colección",
  "collections.description_length_hint": "Límite de 100 caracteres",
  "collections.detail.author_added_you_on_date": "{author} te agregó el {date}",
  "collections.detail.loading": "Cargando colección…",
  "collections.detail.revoke_inclusion": "Quitarme",
  "collections.detail.sensitive_content": "Contenido sensible",
  "collections.detail.sensitive_note": "Esta colección contiene cuentas y contenido que pueden ser sensibles a algunos usuarios.",
  "collections.detail.share": "Compartir esta colección",
  "collections.detail.you_are_in_this_collection": "Te destacaron en esta colección",
  "collections.edit_details": "Editar detalles",
  "collections.error_loading_collections": "Hubo un error al intentar cargar estas colecciones.",
  "collections.hidden_accounts_description": "Bloqueaste o silenciaste a {count, plural, one {este usuario} other {estos usuarios}}",
  "collections.hidden_accounts_link": "{count, plural, one {# cuenta oculta} other {# cuentas ocultas}}",
  "collections.hints.accounts_counter": "{count}/{max} cuentas",
  "collections.last_updated_at": "Última actualización: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# Colección} other {# Colecciones}}",
  "collections.list.created_by_author": "Creadas por {name}",
  "collections.list.created_by_you": "Creadas por vos",
  "collections.list.featuring_you": "En las que te destacan",
  "collections.manage_accounts": "Administrar cuentas",
  "collections.mark_as_sensitive": "Marcar como sensible",
  "collections.mark_as_sensitive_hint": "Oculta la descripción de la colección y las cuentas detrás de una advertencia de contenido. El nombre de la colección seguirá siendo visible.",
  "collections.maximum_collection_count_description": "Tu servidor permite creaciones de hasta {count} colecciones.",
  "collections.maximum_collection_count_reached": "Creaste el número máximo de colecciones",
  "collections.name_length_hint": "Límite de 40 caracteres",
  "collections.new_collection": "Nueva colección",
  "collections.pending_accounts.message": "Las cuentas pueden aparecer como pendientes cuando estamos esperando una respuesta del usuario o su servidor. Solo vos podés ver cuentas pendientes.",
  "collections.pending_accounts.title": "¿Por qué estoy viendo cuentas pendientes?",
  "collections.remove_account": "Quitar",
  "collections.report_collection": "Denunciar esta colección",
  "collections.revoke_collection_inclusion": "Quitarme de esta colección",
  "collections.revoke_inclusion.confirmation": "Saliste de «{collection}»",
  "collections.revoke_inclusion.error": "Hubo un error; por favor, intentalo de nuevo más tarde.",
  "collections.search_accounts_label": "Buscar una cuenta para agregar",
  "collections.search_accounts_max_reached": "Agregaste el número máximo de cuentas",
  "collections.sensitive": "Sensible",
  "collections.share_short": "Compartir",
  "collections.suggestions.can_not_add": "No se puede agregar",
  "collections.suggestions.can_not_add_desc": "Estas cuentas pueden haber optado por no ser descubiertas, o podrían estar en un servidor que no soporta colecciones.",
  "collections.suggestions.must_follow": "Deben seguirse primero",
  "collections.suggestions.must_follow_desc": "Estas cuentas revisan todas las solicitudes de seguimiento. Los seguidores de estas cuentas pueden agregarlas a colecciones.",
  "collections.topic_hint": "Agregá una etiqueta que ayude a otros usuarios a entender el tema principal de esta colección.",
  "collections.topic_special_chars_hint": "Los símbolos se eliminarán al guardar",
  "collections.unlisted_collections_description": "Estas colecciones no aparecen en tu perfil para ser mostradas a otras cuentas. Cualquier persona que tenga el enlace puede descubrirlas.",
  "collections.unlisted_collections_with_count": "Colecciones no listadas ({count})",
  "collections.view_collection": "Abrir colección",
  "collections.visibility_public": "Pública",
  "collections.visibility_public_hint": "Puede ser descubierta en los resultados de búsqueda y en otras áreas donde aparezcan recomendaciones.",
  "collections.visibility_title": "Visibilidad",
  "collections.visibility_unlisted": "No listada",
  "collections.visibility_unlisted_hint": "Visible para quien tenga el enlace. Oculta de los resultados de búsqueda y recomendaciones.",
  "column.about": "Información",
  "column.blocks": "Usuarios bloqueados",
  "column.bookmarks": "Marcadores",
  "column.community": "Línea temporal local",
  "column.create_list": "Crear lista",
  "column.direct": "Menciones privadas",
  "column.directory": "Explorar perfiles",
  "column.domain_blocks": "Dominios bloqueados",
  "column.edit_list": "Editar lista",
  "column.favourites": "Favoritos",
  "column.firehose": "Líneas temporales en vivo",
  "column.firehose_local": "Línea temporal en vivo para este servidor",
  "column.firehose_singular": "Línea temporal en vivo",
  "column.follow_requests": "Solicitudes de seguimiento",
  "column.home": "Principal",
  "column.list_members": "Administrar miembros de la lista",
  "column.lists": "Listas",
  "column.mutes": "Usuarios silenciados",
  "column.notifications": "Notificaciones",
  "column.other_collections": "Colecciones de {name}",
  "column.pins": "Mensajes fijados",
  "column.public": "Línea temporal federada",
  "column.your_collections": "Tus colecciones",
  "column_back_button.label": "Volver",
  "column_header.hide_settings": "Ocultar configuración",
  "column_header.moveLeft_settings": "Mover columna a la izquierda",
  "column_header.moveRight_settings": "Mover columna a la derecha",
  "column_header.pin": "Fijar",
  "column_header.show_settings": "Mostrar configuración",
  "column_header.unpin": "Dejar de fijar",
  "column_search.cancel": "Cancelar",
  "combobox.close_results": "Cerrar resultados",
  "combobox.loading": "Cargando…",
  "combobox.no_results_found": "No hay resultados para esta búsqueda",
  "combobox.open_results": "Abrir resultados",
  "combobox.results_available": "{count, plural, one {# sugerencia} other {# sugerencias}} disponible. Usá las teclas de flecha arriba y flecha abajo para navegar. Toca la tecla «Intro ⏎» para seleccionar.",
  "community.column_settings.local_only": "Solo local",
  "community.column_settings.media_only": "Solo medios",
  "community.column_settings.remote_only": "Solo remoto",
  "compose.error.blank_post": "El mensaje no puede estar en blanco.",
  "compose.language.change": "Cambiar idioma",
  "compose.language.search": "Buscar idiomas…",
  "compose.published.body": "Mensaje publicado.",
  "compose.published.open": "Abrir",
  "compose.saved.body": "Mensaje guardado.",
  "compose_form.direct_message_warning_learn_more": "Aprendé más",
  "compose_form.encryption_warning": "Los mensajes en Mastodon no están cifrados de extremo a extremo. No compartas ninguna información sensible al usar Mastodon.",
  "compose_form.hashtag_warning": "Este mensaje no se mostrará bajo ninguna etiqueta porque no es público. Solo los mensajes públicos se pueden buscar por etiquetas.",
  "compose_form.lock_disclaimer": "Tu cuenta no es {locked}. Todos pueden seguirte para ver tus mensajes marcados como \"Sólo para seguidores\".",
  "compose_form.lock_disclaimer.lock": "privada",
  "compose_form.placeholder": "¿Qué onda?",
  "compose_form.poll.duration": "Duración de la encuesta",
  "compose_form.poll.multiple": "Múltiples opciones",
  "compose_form.poll.option_placeholder": "Opción {number}",
  "compose_form.poll.single": "Opción única",
  "compose_form.poll.switch_to_multiple": "Cambiar encuesta para permitir opciones múltiples",
  "compose_form.poll.switch_to_single": "Cambiar encuesta para permitir una sola opción",
  "compose_form.poll.type": "Estilo",
  "compose_form.publish": "Enviar",
  "compose_form.reply": "Responder",
  "compose_form.save_changes": "Actualizar",
  "compose_form.spoiler.marked": "Quitar advertencia de contenido",
  "compose_form.spoiler.unmarked": "Agregar advertencia de contenido",
  "compose_form.spoiler_placeholder": "Advertencia de contenido (opcional)",
  "confirmation_modal.cancel": "Cancelar",
  "confirmations.block.confirm": "Bloquear",
  "confirmations.delete.confirm": "Eliminar",
  "confirmations.delete.message": "¿De verdad querés eliminar este mensaje?",
  "confirmations.delete.title": "¿Eliminar mensaje?",
  "confirmations.delete_collection.confirm": "Eliminar",
  "confirmations.delete_collection.message": "Esta acción no se puede deshacer.",
  "confirmations.delete_collection.title": "¿Eliminar «{name}»?",
  "confirmations.delete_list.confirm": "Eliminar",
  "confirmations.delete_list.message": "¿De verdad querés eliminar permanentemente esta lista?",
  "confirmations.delete_list.title": "¿Eliminar lista?",
  "confirmations.discard_draft.confirm": "Descartar y continuar",
  "confirmations.discard_draft.edit.cancel": "Reanudar edición",
  "confirmations.discard_draft.edit.message": "Al continuar, se descartará cualquier cambio que hayás hecho en el mensaje que estás editando actualmente.",
  "confirmations.discard_draft.edit.title": "¿Descartar cambios en tu mensaje?",
  "confirmations.discard_draft.post.cancel": "Reanudar borrador",
  "confirmations.discard_draft.post.message": "Al continuar, se descartará el mensaje que estás componiendo actualmente.",
  "confirmations.discard_draft.post.title": "¿Descartar tu borrador?",
  "confirmations.discard_edit_media.confirm": "Descartar",
  "confirmations.discard_edit_media.message": "Tenés cambios sin guardar en la descripción de medios o en la vista previa, ¿querés descartarlos de todos modos?",
  "confirmations.follow_to_list.confirm": "Seguir y agregar a la lista",
  "confirmations.follow_to_list.message": "Necesitás seguir a {name} para agregarle a una lista.",
  "confirmations.follow_to_list.title": "¿Querés seguirle?",
  "confirmations.hide_featured_tab.confirm": "Ocultar pestaña",
  "confirmations.hide_featured_tab.intro": "Podés cambiar esto en cualquier momento en <i>Editar perfil > Configuración de pestaña de perfil</i>.",
  "confirmations.hide_featured_tab.message": "Esto ocultará la pestaña para los usuarios en {serverName} y otros servidores que tengan instalada la última versión de Mastodon. Otras pantallas pueden variar.",
  "confirmations.hide_featured_tab.title": "¿Ocultar la pestaña «Destacados»?",
  "confirmations.logout.confirm": "Cerrar sesión",
  "confirmations.logout.message": "¿De verdad querés cerrar la sesión?",
  "confirmations.logout.title": "¿Cerrar sesión?",
  "confirmations.missing_alt_text.confirm": "Agregar texto alternativo",
  "confirmations.missing_alt_text.message": "Tu mensaje contiene medios sin texto alternativo. Agregar descripciones ayuda a que tu contenido sea accesible para más personas.",
  "confirmations.missing_alt_text.secondary": "Enviar de todos modos",
  "confirmations.missing_alt_text.title": "¿Agregar texto alternativo?",
  "confirmations.mute.confirm": "Silenciar",
  "confirmations.private_quote_notify.cancel": "Volver a editar",
  "confirmations.private_quote_notify.confirm": "Enviar mensaje",
  "confirmations.private_quote_notify.do_not_show_again": "No mostrarme este mensaje de nuevo",
  "confirmations.private_quote_notify.message": "La cuenta a la que estás citando y otras menciones serán notificadas y podrán ver tu mensaje, incluso si no te están siguiendo.",
  "confirmations.private_quote_notify.title": "¿Compartir con seguidores y usuarios mencionados?",
  "confirmations.quiet_post_quote_info.dismiss": "No recordar de nuevo",
  "confirmations.quiet_post_quote_info.got_it": "Entendido",
  "confirmations.quiet_post_quote_info.message": "Al citar un mensaje público pero silencioso, tu mensaje se ocultará de las líneas temporales de tendencias.",
  "confirmations.quiet_post_quote_info.title": "Citado de mensajes públicos pero silenciosos",
  "confirmations.redraft.confirm": "Eliminar mensaje original y editarlo",
  "confirmations.redraft.message": "¿De verdad querés eliminar este mensaje y volver a editarlo? Se perderán las veces marcadas como favorito y sus adhesiones, y las respuestas al mensaje original quedarán huérfanas.",
  "confirmations.redraft.title": "¿Eliminar y volver a redactar mensaje?",
  "confirmations.remove_from_followers.confirm": "Quitar seguidor",
  "confirmations.remove_from_followers.message": "{name} dejará de seguirte. ¿De verdad querés continuar?",
  "confirmations.remove_from_followers.title": "¿Quitar seguidor?",
  "confirmations.revoke_collection_inclusion.confirm": "Quitarme",
  "confirmations.revoke_collection_inclusion.message": "Esta acción es permanente, y el autor no podrá volver a agregarte a la colección más adelante.",
  "confirmations.revoke_collection_inclusion.title": "¿Querés quitarte de esta colección?",
  "confirmations.revoke_quote.confirm": "Eliminar mensaje",
  "confirmations.revoke_quote.message": "Esta acción no se puede deshacer.",
  "confirmations.revoke_quote.title": "¿Eliminar mensaje?",
  "confirmations.unblock.confirm": "Desbloquear",
  "confirmations.unblock.title": "¿Desbloquear a {name}?",
  "confirmations.unfollow.confirm": "Dejar de seguir",
  "confirmations.unfollow.title": "¿Dejar de seguir a {name}?",
  "confirmations.withdraw_request.confirm": "Retirar solicitud",
  "confirmations.withdraw_request.title": "¿Retirar solicitud de seguimiento a {name}?",
  "content_warning.hide": "Ocultar mensaje",
  "content_warning.show": "Mostrar de todos modos",
  "content_warning.show_more": "Mostrar más",
  "content_warning.show_short": "Mostrar",
  "conversation.delete": "Eliminar conversación",
  "conversation.mark_as_read": "Marcar como leída",
  "conversation.open": "Ver conversación",
  "conversation.with": "Con {names}",
  "copy_icon_button.copied": "Copiado en el portapapeles",
  "copy_icon_button.copy_this_text": "Copiar enlace al portapapeles",
  "copypaste.copied": "Copiado",
  "copypaste.copy_to_clipboard": "Copiar al portapapeles",
  "directory.federated": "Desde fediverso conocido",
  "directory.local": "Solo de {domain}",
  "directory.new_arrivals": "Recién llegados",
  "directory.recently_active": "Recientemente activos",
  "disabled_account_banner.account_settings": "Config. de la cuenta",
  "disabled_account_banner.text": "Tu cuenta {disabledAccount} está actualmente deshabilitada.",
  "dismissable_banner.community_timeline": "Estos son los mensajes públicos más recientes de cuentas alojadas en {domain}.",
  "dismissable_banner.dismiss": "Descartar",
  "dismissable_banner.public_timeline": "Estos son los mensajes más recientes de cuentas del Fediverso a las que sigue la gente de {domain}.",
  "domain_block_modal.block": "Bloquear servidor",
  "domain_block_modal.block_account_instead": "Bloquear @{name} en su lugar",
  "domain_block_modal.they_can_interact_with_old_posts": "Las cuentas de este servidor pueden interactuar con tus mensajes antiguos.",
  "domain_block_modal.they_cant_follow": "Nadie de este servidor puede seguirte.",
  "domain_block_modal.they_wont_know": "No sabrán que fueron bloqueados.",
  "domain_block_modal.title": "¿Bloquear dominio?",
  "domain_block_modal.you_will_lose_num_followers": "Perderás {followersCount, plural, one {{followersCountDisplay} seguidor} other {{followersCountDisplay} seguidores}} y {followingCount, plural, one {{followingCountDisplay} cuenta que seguís} other {{followingCountDisplay} cuentas que seguís}}.",
  "domain_block_modal.you_will_lose_relationships": "Perderás a todos los seguidores y cuentas a las que seguís de este servidor.",
  "domain_block_modal.you_wont_see_posts": "No verás mensajes ni notificaciones de usuarios en este servidor.",
  "domain_pill.activitypub_lets_connect": "Te permite conectar e interactuar con cuentas no solo en Mastodon, sino también a través de diferentes aplicaciones sociales.",
  "domain_pill.activitypub_like_language": "ActivityPub es como el idioma que Mastodon habla con otras redes sociales.",
  "domain_pill.server": "Servidor",
  "domain_pill.their_handle": "Su alias:",
  "domain_pill.their_server": "Su hogar digital, donde residen todoas sus mensajes.",
  "domain_pill.their_username": "Su identificador único en su servidor. Es posible encontrar cuentas con el mismo nombre de usuario en diferentes servidores.",
  "domain_pill.username": "Nombre de usuario",
  "domain_pill.whats_in_a_handle": "¿En qué consiste el alias?",
  "domain_pill.who_they_are": "Los alias indican quiénes son y dónde se encuentran, y gracias a ellos podés interactuar con otras cuentas a través de las redes sociales compatibles con <button>ActivityPub</button>.",
  "domain_pill.who_you_are": "Los alias dicen quién sos y dónde estás, y gracias a ellos podés interactuar con otras cuentas a través de las redes sociales compatibles con <button>ActivityPub</button>.",
  "domain_pill.your_handle": "Tu alias:",
  "domain_pill.your_server": "Tu hogar digital, donde residen todos tus mensajes. ¿No te gusta este sitio? Mudate a otro servidor en cualquier momento y llevate a tus seguidores.",
  "domain_pill.your_username": "Tu identificador único en este servidor. Es posible encontrar cuentas con el mismo nombre de usuario en diferentes servidores.",
  "dropdown.empty": "Seleccioná una opción",
  "email_subscriptions.email": "Correo electrónico",
  "email_subscriptions.form.action": "Suscribite",
  "email_subscriptions.form.bottom": "Obtené publicaciones en tu bandeja de entrada sin crear una cuenta de Mastodon. Desuscribite en cualquier momento. Para más información, consultá la <a>Política de privacidad</a>.",
  "email_subscriptions.form.title": "Suscribite para recibir actualizaciones por correo electrónico de {name}",
  "email_subscriptions.submitted.lead": "Revisá tu bandeja de entrada para confirmar tu suscripción, así podés recibir actualizaciones por correo electrónico.",
  "email_subscriptions.submitted.title": "Un paso más",
  "email_subscriptions.validation.email.blocked": "Proveedor de correo bloqueado",
  "email_subscriptions.validation.email.invalid": "Dirección de correo electrónico no válida",
  "embed.instructions": "Insertá este mensaje a tu sitio web copiando el código de abajo.",
  "embed.preview": "Así es cómo se verá:",
  "emoji_button.activity": "Actividad",
  "emoji_button.clear": "Limpiar",
  "emoji_button.custom": "Personalizado",
  "emoji_button.flags": "Banderas",
  "emoji_button.food": "Comida y bebida",
  "emoji_button.label": "Insertar emoji",
  "emoji_button.nature": "Naturaleza",
  "emoji_button.not_found": "No se encontraron emojis coincidentes",
  "emoji_button.objects": "Objetos",
  "emoji_button.people": "Gente",
  "emoji_button.recent": "Usados frecuentemente",
  "emoji_button.search": "Buscar...",
  "emoji_button.search_results": "Resultados de búsqueda",
  "emoji_button.symbols": "Símbolos",
  "emoji_button.travel": "Viajes y lugares",
  "empty_column.account_featured.other": "{acct} todavía no destacó nada.",
  "empty_column.account_featured_self.no_collections_button": "Crear colección",
  "empty_column.account_featured_self.no_collections_hide_tab": "En su lugar, ocultar esta pestaña",
  "empty_column.account_featured_self.pre_collections": "Mantenete pendiente de las colecciones",
  "empty_column.account_featured_self.pre_collections_desc": "Las colecciones (que vendrán en Mastodon 4.6) te permiten crear tus propias listas de cuentas seleccionadas para recomendar a otras personas.",
  "empty_column.account_featured_self.showcase_accounts": "Mostrá tus cuentas favoritas",
  "empty_column.account_featured_self.showcase_accounts_desc": "Las colecciones son listas de cuentas seleccionadas para ayudar a otras personas a descubrir más del Fediverso.",
  "empty_column.account_featured_unknown.other": "Esta cuenta todavía no destacó nada.",
  "empty_column.account_hides_collections": "Este usuario eligió no publicar esta información",
  "empty_column.account_suspended": "Cuenta suspendida",
  "empty_column.account_timeline": "¡No hay mensajes acá!",
  "empty_column.account_unavailable": "Perfil no disponible",
  "empty_column.blocks": "Todavía no bloqueaste a ningún usuario.",
  "empty_column.bookmarked_statuses": "Todavía no tenés mensajes guardados en \"Marcadores\". Cuando guardés uno en \"Marcadores\", se mostrará acá.",
  "empty_column.collections.featured_in": "Todavía no te agregaron a ninguna colección.",
  "empty_column.community": "La línea temporal local está vacía. ¡Escribí algo en modo público para que se empiece a correr la bola!",
  "empty_column.direct": "Todavía no tenés ninguna mención privada. Cuando enviés o recibás una, se mostrará acá.",
  "empty_column.disabled_feed": "Esta línea temporal fue deshabilitada por los administradores de tu servidor.",
  "empty_column.domain_blocks": "Todavía no hay dominios bloqueados.",
  "empty_column.explore_statuses": "No hay nada en tendencia ahora mismo. ¡Volvé a revisar más tarde!",
  "empty_column.favourited_statuses": "Todavía no tenés mensajes favoritos. Cuando marqués uno como favorito, se mostrará acá.",
  "empty_column.favourites": "Todavía nadie marcó este mensaje como favorito. Cuando alguien lo haga, se mostrará acá.",
  "empty_column.follow_requests": "Todavía no tenés ninguna solicitud de seguimiento. Cuando recibás una, se mostrará acá.",
  "empty_column.followed_tags": "Todavía no tenés ninguna etiqueta en seguimiento. Cuando tengás una, se mostrará acá.",
  "empty_column.hashtag": "Todavía no hay nada con esta etiqueta.",
  "empty_column.home": "¡Tu línea temporal principal está vacía! Seguí a más cuentas para llenarla.",
  "empty_column.list": "Todavía no hay nada en esta lista. Cuando miembros de esta lista envíen nuevos mensaje, se mostrarán acá.",
  "empty_column.mutes": "Todavía no silenciaste a ningún usuario.",
  "empty_column.notification_requests": "¡Todo limpio! No hay nada acá. Cuando recibás nuevas notificaciones, aparecerán acá, acorde a tu configuración.",
  "empty_column.notifications": "Todavía no tenés ninguna notificación. Cuando otras cuentas interactúen con vos, vas a ver la notificación acá.",
  "empty_column.public": "¡Naranja! Escribí algo públicamente, o seguí usuarios manualmente de otros servidores para ir llenando esta línea temporal",
  "empty_state.no_results": "No hay resultados",
  "error.no_hashtag_feed_access": "Create una cuenta o iniciá sesión para seguir esta etiqueta.",
  "error.unexpected_crash.explanation": "Debido a un error en nuestro código o a un problema de compatibilidad con el navegador web, esta página no se pudo mostrar correctamente.",
  "error.unexpected_crash.explanation_addons": "No se pudo mostrar correctamente esta página. Este error probablemente es causado por un complemento del navegador web o por herramientas de traducción automática.",
  "error.unexpected_crash.next_steps": "Intentá recargar la página. Si eso no ayuda, podés usar Mastodon a través de un navegador web diferente o aplicación nativa.",
  "error.unexpected_crash.next_steps_addons": "Intentá deshabilitarlos y recargá la página. Si eso no ayuda, podés usar Mastodon a través de un navegador web diferente o aplicación nativa.",
  "errors.unexpected_crash.copy_stacktrace": "Copiar stacktrace al portapapeles",
  "errors.unexpected_crash.report_issue": "Informar problema",
  "explore.suggested_follows": "Cuentas",
  "explore.title": "En tendencia",
  "explore.trending_links": "Noticias",
  "explore.trending_statuses": "Mensajes",
  "explore.trending_tags": "Etiquetas",
  "featured_carousel.current": "<sr>Mensaje</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Mensaje fijado} other {Mensajes fijados}}",
  "featured_carousel.slide": "Mensaje {current, number} de {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Recientemente, publicaste sobre {items}. ¿Querés agregarlas como etiquetas destacadas?",
  "featured_tags.suggestions.add": "Agregar",
  "featured_tags.suggestions.added": "Administrá tus etiquetas destacadas cuando quieras en <link>Editar perfil > Etiquetas destacadas</link>.",
  "featured_tags.suggestions.dismiss": "No, gracias",
  "filter_modal.added.context_mismatch_explanation": "Esta categoría de filtro no se aplica al contexto en el que accediste a este mensaje. Si querés que el mensaje sea filtrado también en este contexto, vas a tener que editar el filtro.",
  "filter_modal.added.context_mismatch_title": "¡El contexto no coincide!",
  "filter_modal.added.expired_explanation": "Esta categoría de filtro caducó; vas a necesitar cambiar la fecha de caducidad para que se aplique.",
  "filter_modal.added.expired_title": "¡Filtro caducado!",
  "filter_modal.added.review_and_configure": "Para revisar y configurar esta categoría de filtros, visitá a la {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Configuración de filtro",
  "filter_modal.added.settings_link": "página de configuración",
  "filter_modal.added.short_explanation": "Este mensaje fue agregado a la siguiente categoría de filtros: {title}.",
  "filter_modal.added.title": "¡Filtro agregado!",
  "filter_modal.select_filter.context_mismatch": "no aplica a este contexto",
  "filter_modal.select_filter.expired": "expirado",
  "filter_modal.select_filter.prompt_new": "Nueva categoría: {name}",
  "filter_modal.select_filter.search": "Buscar o crear",
  "filter_modal.select_filter.subtitle": "Usar una categoría existente o crear una nueva",
  "filter_modal.select_filter.title": "Filtrar este mensaje",
  "filter_modal.title.status": "Filtrar un mensaje",
  "filter_warning.matches_filter": "Coincide con el filtro “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "De {count, plural, =0 {nadie} one {una persona} other {# personas}} que podrías conocer",
  "filtered_notifications_banner.title": "Notificaciones filtradas",
  "firehose.all": "Todos",
  "firehose.local": "Este servidor",
  "firehose.remote": "Otros servidores",
  "follow_request.authorize": "Autorizar",
  "follow_request.reject": "Rechazar",
  "follow_requests.unlocked_explanation": "A pesar de que tu cuenta no es privada, el equipo de {domain} pensó que podrías querer revisar manualmente las solicitudes de seguimiento de estas cuentas.",
  "follow_suggestions.curated_suggestion": "Selección del equipo",
  "follow_suggestions.dismiss": "No mostrar de nuevo",
  "follow_suggestions.featured_longer": "Seleccionada a mano por el equipo de {domain}",
  "follow_suggestions.friends_of_friends_longer": "Populares entre las cuentas que seguís",
  "follow_suggestions.hints.featured": "Este perfil fue seleccionado a mano por el equipo de {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Este perfil es popular entre las cuentas que seguís.",
  "follow_suggestions.hints.most_followed": "Este perfil es uno de los más seguidos en {domain}.",
  "follow_suggestions.hints.most_interactions": "Este perfil ha estado recibiendo recientemente mucha atención en {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Este perfil es similar a los que comenzaste a seguir.",
  "follow_suggestions.personalized_suggestion": "Sugerencia personalizada",
  "follow_suggestions.popular_suggestion": "Sugerencia popular",
  "follow_suggestions.popular_suggestion_longer": "Popular en {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Similares a perfiles que comenzaste a seguir recientemente",
  "follow_suggestions.view_all": "Ver todo",
  "follow_suggestions.who_to_follow": "A quién seguir",
  "followed_tags": "Etiquetas seguidas",
  "followers.hide_other_followers": "Este usuario eligió no hacer visibles a sus otros seguidores",
  "followers.title": "Seguiendo a {name}",
  "following.hide_other_following": "Este usuario eligió no hacer visibles al resto de quienes lo siguen",
  "following.title": "Seguido por {name}",
  "footer.about": "Información",
  "footer.about_mastodon": "Acerca de Mastodon",
  "footer.about_server": "Acerca de {domain}",
  "footer.about_this_server": "Información",
  "footer.directory": "Directorio de perfiles",
  "footer.get_app": "Conseguí la aplicación",
  "footer.keyboard_shortcuts": "Atajos de teclado",
  "footer.privacy_policy": "Política de privacidad",
  "footer.source_code": "Ver código fuente",
  "footer.status": "Estado",
  "footer.terms_of_service": "Términos del servicio",
  "form_error.blank": "El campo no puede estar en blanco.",
  "form_field.optional": "(opcional)",
  "generic.saved": "Guardado",
  "getting_started.heading": "Inicio de Mastodon",
  "hashtag.admin_moderation": "Abrir interface de moderación para #{name}",
  "hashtag.browse": "Ver publicaciones con #{hashtag}",
  "hashtag.browse_from_account": "Ver publicaciones de @{name} con #{hashtag}",
  "hashtag.column_header.tag_mode.all": "y {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_header.tag_mode.none": "sin {additional}",
  "hashtag.column_settings.select.no_options_message": "No se encontraron sugerencias",
  "hashtag.column_settings.select.placeholder": "Introducí etiquetas…",
  "hashtag.column_settings.tag_mode.all": "Todas estas",
  "hashtag.column_settings.tag_mode.any": "Cualquiera de estas",
  "hashtag.column_settings.tag_mode.none": "Ninguna de estas",
  "hashtag.column_settings.tag_toggle": "Incluir etiquetas adicionales para esta columna",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participante} other {{counter} participantes}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} mensaje} other {{counter} mensajes}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} mensaje} other {{counter} mensajes}} hoy",
  "hashtag.feature": "Destacar en el perfil",
  "hashtag.follow": "Seguir etiqueta",
  "hashtag.mute": "Silenciar #{hashtag}",
  "hashtag.unfeature": "No destacar en el perfil",
  "hashtag.unfollow": "Dejar de seguir etiqueta",
  "hashtags.and_other": "…y {count, plural, other {# más}}",
  "hints.profiles.followers_may_be_missing": "Es posible que falten seguidores de este perfil.",
  "hints.profiles.follows_may_be_missing": "Es posible que falten seguimientos a este perfil.",
  "hints.profiles.posts_may_be_missing": "Es posible que falten mensajes de este perfil.",
  "hints.profiles.see_more_followers": "Ver más seguidores en {domain}",
  "hints.profiles.see_more_follows": "Ver más seguimientos en {domain}",
  "hints.profiles.see_more_posts": "Ver más mensajes en {domain}",
  "home.column_settings.show_quotes": "Mostrar citas",
  "home.column_settings.show_reblogs": "Mostrar adhesiones",
  "home.column_settings.show_replies": "Mostrar respuestas",
  "home.hide_announcements": "Ocultar anuncios",
  "home.pending_critical_update.body": "Por favor, ¡actualizá tu servidor de Mastodon lo antes posible!",
  "home.pending_critical_update.link": "Ver actualizaciones",
  "home.pending_critical_update.title": "¡Actualización de seguridad crítica disponible!",
  "home.show_announcements": "Mostrar anuncios",
  "ignore_notifications_modal.disclaimer": "Mastodon no puede informar a los usuarios que ignoraste sus notificaciones. Ignorar notificaciones no impedirá que se sigan enviando los mensajes.",
  "ignore_notifications_modal.filter_instead": "Filtrar en vez de ignorar",
  "ignore_notifications_modal.filter_to_act_users": "Aún podrás aceptar, rechazar o denunciar a usuarios",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrar ayuda a evitar confusiones potenciales",
  "ignore_notifications_modal.filter_to_review_separately": "Podés revisar las notificaciones filtradas por separado",
  "ignore_notifications_modal.ignore": "Ignorar notificaciones",
  "ignore_notifications_modal.limited_accounts_title": "¿Ignorar notificaciones de cuentas moderadas?",
  "ignore_notifications_modal.new_accounts_title": "¿Ignorar notificaciones de cuentas nuevas?",
  "ignore_notifications_modal.not_followers_title": "¿Ignorar notificaciones de cuentas que no te siguen?",
  "ignore_notifications_modal.not_following_title": "¿Ignorar notificaciones de cuentas a las que no seguís?",
  "ignore_notifications_modal.private_mentions_title": "¿Ignorar notificaciones de menciones privadas no solicitadas?",
  "info_button.label": "Ayuda",
  "info_button.what_is_alt_text": "<h1>¿Qué es el texto alternativo?</h1> <p>El texto alternativo proporciona descripciones de las imágenes para personas con dificultades visuales, conexiones con escaso ancho de banda o que buscan un contexto adicional.</p> <p>Podés mejorar la accesibilidad y la comprensión para todos escribiendo un texto alternativo claro, conciso y objetivo.</p> <ul><li>Captura los elementos importantes.</li><li>Resumí el texto en imágenes.</li><li>Usá una estructura de frases normal.</li><li>Evitá la información redundante.</li><li>Focalizate en las tendencias y conclusiones clave de los elementos visuales complejos (como diagramas o mapas).</li></ul>",
  "interaction_modal.action": "Para interactuar con el mensaje de {name}, tenés que iniciar sesión en la cuenta del servidor de Mastodon que usés.",
  "interaction_modal.action_follow": "Para seguir a {name}, tenés que iniciar sesión en tu cuenta de cualquier servidor de Mastodon que usés.",
  "interaction_modal.go": "Ir",
  "interaction_modal.no_account_yet": "¿Todavía no tenés cuenta?",
  "interaction_modal.on_another_server": "En un servidor diferente",
  "interaction_modal.on_this_server": "En este servidor",
  "interaction_modal.title": "Iniciá sesión para continuar",
  "interaction_modal.username_prompt": "Por ejemplo: {example}",
  "intervals.full.days": "{number, plural, one {# día} other {# días}}",
  "intervals.full.hours": "{number, plural, one {# hora} other {# horas}}",
  "intervals.full.minutes": "{number, plural, one {# minuto} other {# minutos}}",
  "keyboard_shortcuts.back": "Volver",
  "keyboard_shortcuts.blocked": "Abrir lista de usuarios bloqueados",
  "keyboard_shortcuts.boost": "Adherir al mensaje",
  "keyboard_shortcuts.column": "Enfocar columna",
  "keyboard_shortcuts.compose": "Enfocar el área de texto de redacción",
  "keyboard_shortcuts.description": "Descripción",
  "keyboard_shortcuts.direct": "Abrir columna de menciones privadas",
  "keyboard_shortcuts.down": "Bajar en la lista",
  "keyboard_shortcuts.enter": "Abrir mensaje",
  "keyboard_shortcuts.explore": "Abrir línea temporal de tendencias",
  "keyboard_shortcuts.favourite": "Marcar mensaje como favorito",
  "keyboard_shortcuts.favourites": "Abrir lista de favoritos",
  "keyboard_shortcuts.federated": "Abrir línea temporal federada",
  "keyboard_shortcuts.heading": "Atajos de teclado",
  "keyboard_shortcuts.home": "Abrir línea temporal principal",
  "keyboard_shortcuts.hotkey": "Atajo",
  "keyboard_shortcuts.legend": "Mostrar este texto",
  "keyboard_shortcuts.load_more": "Focalizar el botón «Cargar más»",
  "keyboard_shortcuts.local": "Abrirlínea temporal local",
  "keyboard_shortcuts.mention": "Mencionar al autor",
  "keyboard_shortcuts.muted": "Abrir lista de usuarios silenciados",
  "keyboard_shortcuts.my_profile": "Abrir tu perfil",
  "keyboard_shortcuts.notifications": "Abrir columna de notificaciones",
  "keyboard_shortcuts.open_media": "Abrir archivos de medios",
  "keyboard_shortcuts.pinned": "Abrir lista de mensajes fijados",
  "keyboard_shortcuts.profile": "Abrir perfil del autor",
  "keyboard_shortcuts.quote": "Citar mensaje",
  "keyboard_shortcuts.reply": "Responder al mensaje",
  "keyboard_shortcuts.requests": "Abrir lista de solicitudes de seguimiento",
  "keyboard_shortcuts.search": "Enfocar barra de búsqueda",
  "keyboard_shortcuts.spoilers": "Mostrar/ocultar campo de advertencia de contenido (\"CW\")",
  "keyboard_shortcuts.start": "Abrir columna \"Introducción\"",
  "keyboard_shortcuts.toggle_hidden": "Mostrar/ocultar texto detrás de la advertencia de contenido (\"CW\")",
  "keyboard_shortcuts.toggle_sensitivity": "Mostrar/ocultar medios",
  "keyboard_shortcuts.toot": "Comenzar un mensaje nuevo",
  "keyboard_shortcuts.top": "Mover al principio de la lista",
  "keyboard_shortcuts.translate": "para traducir un mensaje",
  "keyboard_shortcuts.unfocus": "Quitar el foco del área de texto de redacción o de búsqueda",
  "keyboard_shortcuts.up": "Subir en la lista",
  "learn_more_link.got_it": "Entendido",
  "learn_more_link.learn_more": "Aprendé más",
  "lightbox.close": "Cerrar",
  "lightbox.next": "Siguiente",
  "lightbox.previous": "Anterior",
  "lightbox.zoom_in": "Ampliar al tamaño real",
  "lightbox.zoom_out": "Ampliar hasta ajustar",
  "limited_account_hint.action": "Mostrar perfil de todos modos",
  "limited_account_hint.title": "Este perfil fue ocultado por los moderadores de {domain}.",
  "link_preview.author": "Por {name}",
  "link_preview.more_from_author": "Más de {name}",
  "link_preview.shares": "{count, plural, one {{counter} mensaje} other {{counter} mensajes}}",
  "lists.add_member": "Agregar",
  "lists.add_to_list": "Agregar a lista",
  "lists.add_to_lists": "Agregar a {name} a las listas",
  "lists.create": "Crear",
  "lists.create_a_list_to_organize": "Creá una nueva lista para organizar tu línea temporal principal",
  "lists.create_list": "Crear lista",
  "lists.delete": "Eliminar lista",
  "lists.done": "Listo",
  "lists.edit": "Editar lista",
  "lists.exclusive": "Ocultar miembros en la línea temporal principal",
  "lists.exclusive_hint": "Si alguien está en esta lista, ocultalo en tu línea temporal principal para evitar que aparezcan sus mensajes dos veces.",
  "lists.find_users_to_add": "Buscar usuarios para agregar",
  "lists.list_members_count": "{count, plural,one {# miembro} other {# miembros}}",
  "lists.list_name": "Nombre de la lista",
  "lists.new_list_name": "Nombre de la nueva lista",
  "lists.no_lists_yet": "Aún no hay listas.",
  "lists.no_members_yet": "Aún no hay miembros.",
  "lists.no_results_found": "No se encontraron resultados.",
  "lists.remove_member": "Quitar",
  "lists.replies_policy.followed": "Cualquier cuenta seguida",
  "lists.replies_policy.list": "Miembros de la lista",
  "lists.replies_policy.none": "Nadie",
  "lists.save": "Guardar",
  "lists.search": "Buscar",
  "lists.show_replies_to": "Incluir las respuestas de los miembros de la lista a",
  "load_pending": "{count, plural, one {# elemento nuevo} other {# elementos nuevos}}",
  "loading_indicator.label": "Cargando…",
  "media_gallery.hide": "Ocultar",
  "moved_to_account_banner.text": "Tu cuenta {disabledAccount} está actualmente deshabilitada porque te mudaste a {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Ocultar en las notificaciones",
  "mute_modal.hide_options": "Ocultar opciones",
  "mute_modal.indefinite": "Hasta que deje de silenciarlos",
  "mute_modal.show_options": "Mostrar opciones",
  "mute_modal.they_can_mention_and_follow": "Pueden mencionarte y seguirte, pero no verás nada de ellos.",
  "mute_modal.they_wont_know": "No sabrán que fueron silenciados.",
  "mute_modal.title": "¿Silenciar usuario?",
  "mute_modal.you_wont_see_mentions": "No verás mensajes que los mencionen.",
  "mute_modal.you_wont_see_posts": "Todavía pueden ver tus mensajes, pero vos no verás los suyos.",
  "navigation_bar.about": "Información",
  "navigation_bar.account_settings": "Contraseña y seguridad",
  "navigation_bar.administration": "Administración",
  "navigation_bar.advanced_interface": "Abrir en interface web avanzada",
  "navigation_bar.automated_deletion": "Eliminación auto. de mensajes",
  "navigation_bar.blocks": "Usuarios bloqueados",
  "navigation_bar.bookmarks": "Marcadores",
  "navigation_bar.collections": "Colecciones",
  "navigation_bar.direct": "Menciones privadas",
  "navigation_bar.domain_blocks": "Dominios bloqueados",
  "navigation_bar.favourites": "Favoritos",
  "navigation_bar.filters": "Palabras silenciadas",
  "navigation_bar.follow_requests": "Solicitudes de seguimiento",
  "navigation_bar.followed_tags": "Etiquetas seguidas",
  "navigation_bar.follows_and_followers": "Cuentas seguidas y seguidores",
  "navigation_bar.import_export": "Importación y exportación",
  "navigation_bar.lists": "Listas",
  "navigation_bar.live_feed_local": "Línea temporal (local)",
  "navigation_bar.live_feed_public": "Línea temporal (federada)",
  "navigation_bar.logout": "Cerrar sesión",
  "navigation_bar.moderation": "Moderación",
  "navigation_bar.more": "Más",
  "navigation_bar.mutes": "Usuarios silenciados",
  "navigation_bar.opened_in_classic_interface": "Los mensajes, las cuentas y otras páginas específicas se abren predeterminadamente en la interface web clásica.",
  "navigation_bar.preferences": "Configuración",
  "navigation_bar.privacy_and_reach": "Privacidad y alcance",
  "navigation_bar.search": "Buscar",
  "navigation_bar.search_trends": "Búsqueda / Tendencia",
  "navigation_panel.collapse_followed_tags": "Contraer menú de etiquetas seguidas",
  "navigation_panel.collapse_lists": "Colapsar menú de lista",
  "navigation_panel.expand_followed_tags": "Expandir menú de etiquetas seguidas",
  "navigation_panel.expand_lists": "Expandir menú de lista",
  "not_signed_in_indicator.not_signed_in": "Necesitás iniciar sesión para acceder a este recurso.",
  "notification.added_to_collection": "{name} te agregó a una colección",
  "notification.admin.report": "{name} denunció a {target}",
  "notification.admin.report_account": "{name} denunció {count, plural, one {un mensaje} other {# mensajes}} de {target} por {category}",
  "notification.admin.report_account_other": "{name} denunció {count, plural, one {un mensaje} other {# mensajes}} de {target}",
  "notification.admin.report_statuses": "{name} denunció a {target} por {category}",
  "notification.admin.report_statuses_other": "{name} denunció a {target}",
  "notification.admin.sign_up": "Se registró {name}",
  "notification.admin.sign_up.name_and_others": "Se registraron {name} y {count, plural, one {# cuenta más} other {# cuentas más}}",
  "notification.annual_report.message": "¡Tu #Wrapstodon {year} te espera! ¡Desvelá los momentos más destacados y memorables de tu año en Mastodon!",
  "notification.annual_report.view": "Ver #Wrapstodon",
  "notification.collection_update": "{name} editó una colección en la que estás",
  "notification.favourite": "{name} marcó tu mensaje como favorito",
  "notification.favourite.name_and_others_with_link": "{name} y <a>{count, plural, one {# cuenta más} other {# cuentas más}}</a> marcaron tu mensaje como favorito",
  "notification.favourite_pm": "{name} marcó como favorito tu mención privada",
  "notification.favourite_pm.name_and_others_with_link": "{name} y <a>{count, plural, one {# más} other {# más}}</a> marcaron como favorito tu mención privada",
  "notification.follow": "{name} te empezó a seguir",
  "notification.follow.name_and_others": "{name} y <a>{count, plural, one {# cuenta más} other {# cuentas más}}</a> te están siguiendo",
  "notification.follow_request": "{name} solicitó seguirte",
  "notification.follow_request.name_and_others": "{name} y {count, plural, one {# cuenta más} other {# cuentas más}} solicitaron seguirte",
  "notification.label.mention": "Mención",
  "notification.label.private_mention": "Mención privada",
  "notification.label.private_reply": "Respuesta privada",
  "notification.label.quote": "{name} citó tu mensaje",
  "notification.label.reply": "Respuesta",
  "notification.mention": "Mención",
  "notification.mentioned_you": "{name} te mencionó",
  "notification.moderation-warning.learn_more": "Aprendé más",
  "notification.moderation_warning": "Recibiste una advertencia de moderación",
  "notification.moderation_warning.action_delete_statuses": "Se eliminaron algunos de tus mensajes.",
  "notification.moderation_warning.action_disable": "Se deshabilitó tu cuenta.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Se marcaron como sensibles a algunos de tus mensajes.",
  "notification.moderation_warning.action_none": "Tu cuenta recibió una advertencia de moderación.",
  "notification.moderation_warning.action_sensitive": "A partir de ahora, tus mensajes serán marcados como sensibles.",
  "notification.moderation_warning.action_silence": "Tu cuenta fue limitada.",
  "notification.moderation_warning.action_suspend": "Tu cuenta fue suspendida.",
  "notification.own_poll": "Tu encuesta finalizó",
  "notification.poll": "Finalizó una encuesta en la que votaste",
  "notification.quoted_update": "{name} editó un mensaje que citaste",
  "notification.reblog": "{name} adhirió a tu mensaje",
  "notification.reblog.name_and_others_with_link": "{name} y <a>{count, plural, one {# cuenta más} other {# cuentas más}}</a> marcaron tu mensaje como favorito",
  "notification.relationships_severance_event": "Conexiones perdidas con {name}",
  "notification.relationships_severance_event.account_suspension": "Un administrador de {from} suspendió a {target}, lo que significa que ya no podés recibir actualizaciones de esa cuenta o interactuar con la misma.",
  "notification.relationships_severance_event.domain_block": "Un administrador de {from} bloqueó a {target}, incluyendo {followersCount} de tus seguidores y {followingCount, plural, one {# cuenta} other {# cuentas}} que seguís.",
  "notification.relationships_severance_event.learn_more": "Aprendé más",
  "notification.relationships_severance_event.user_domain_block": "Bloqueaste a {target}, eliminando {followersCount} de tus seguidores y {followingCount, plural, one {# cuenta} other {# cuentas}} que seguís.",
  "notification.status": "{name} acaba de enviar un mensaje",
  "notification.update": "{name} editó un mensaje",
  "notification_requests.accept": "Aceptar",
  "notification_requests.accept_multiple": "{count, plural, one {Aceptar # solicitud…} other {Aceptar # solicitudes…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Aceptar solicitud} other {Aceptar solicitudes}}",
  "notification_requests.confirm_accept_multiple.message": "Estás a punto de aceptar {count, plural, one {una solicitud} other {# solicitudes}}. ¿De verdad querés continuar?",
  "notification_requests.confirm_accept_multiple.title": "¿Aceptar solicitudes de notificación?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Descartar solicitud} other {Descartar solicitudes}}",
  "notification_requests.confirm_dismiss_multiple.message": "Estás a punto de descartar {count, plural, one {una solicitud} other {# solicitudes}}. No vas a poder acceder fácilmente a {count, plural, one {ella} other {ellas}} de nuevo. ¿De verdad querés continuar?",
  "notification_requests.confirm_dismiss_multiple.title": "¿Descartar solicitudes de notificación?",
  "notification_requests.dismiss": "Descartar",
  "notification_requests.dismiss_multiple": "{count, plural, one {Descartar # solicitud…} other {Descartar # solicitudes…}}",
  "notification_requests.edit_selection": "Editar",
  "notification_requests.exit_selection": "Listo",
  "notification_requests.explainer_for_limited_account": "Las notificaciones de esta cuenta fueron filtradas porque la misma fue limitada por un moderador.",
  "notification_requests.explainer_for_limited_remote_account": "Las notificaciones de esta cuenta fueron filtradas porque la cuenta o su servidor fueron limitados por un moderador.",
  "notification_requests.maximize": "Maximizar",
  "notification_requests.minimize_banner": "Minimizar la barra de notificaciones filtradas",
  "notification_requests.notifications_from": "Notificaciones de {name}",
  "notification_requests.title": "Notificaciones filtradas",
  "notification_requests.view": "Ver notificaciones",
  "notifications.clear": "Limpiar notificaciones",
  "notifications.clear_confirmation": "¿De verdad querés limpiar todas tus notificaciones permanentemente?",
  "notifications.clear_title": "¿Limpiar notificaciones?",
  "notifications.column_settings.admin.report": "Nuevas denuncias:",
  "notifications.column_settings.admin.sign_up": "Nuevos registros:",
  "notifications.column_settings.alert": "Notificaciones de escritorio",
  "notifications.column_settings.favourite": "Favoritos:",
  "notifications.column_settings.filter_bar.advanced": "Mostrar todas las categorías",
  "notifications.column_settings.filter_bar.category": "Barra de filtrado rápido",
  "notifications.column_settings.follow": "Nuevos seguidores:",
  "notifications.column_settings.follow_request": "Nuevas solicitudes de seguimiento:",
  "notifications.column_settings.group": "Agrupar",
  "notifications.column_settings.mention": "Menciones:",
  "notifications.column_settings.poll": "Resultados de la encuesta:",
  "notifications.column_settings.push": "Notificaciones push",
  "notifications.column_settings.quote": "Citas:",
  "notifications.column_settings.reblog": "Adhesiones:",
  "notifications.column_settings.show": "Mostrar en columna",
  "notifications.column_settings.sound": "Reproducir sonido",
  "notifications.column_settings.status": "Nuevos mensajes:",
  "notifications.column_settings.unread_notifications.category": "Notificaciones sin leer",
  "notifications.column_settings.unread_notifications.highlight": "Resaltar notificaciones no leídas",
  "notifications.column_settings.update": "Ediciones:",
  "notifications.filter.all": "Todas",
  "notifications.filter.boosts": "Adhesiones",
  "notifications.filter.favourites": "Favoritos",
  "notifications.filter.follows": "Seguidores",
  "notifications.filter.mentions": "Menciones",
  "notifications.filter.polls": "Resultados de encuesta",
  "notifications.filter.statuses": "Actualizaciones de cuentas que seguís",
  "notifications.grant_permission": "Conceder permiso.",
  "notifications.group": "{count} notificaciones",
  "notifications.mark_as_read": "Marcar cada notificación como leída",
  "notifications.permission_denied": "Las notificaciones de escritorio no están disponibles, debido a una solicitud de permiso del navegador web previamente denegada",
  "notifications.permission_denied_alert": "No se pueden habilitar las notificaciones de escritorio, ya que el permiso del navegador fue denegado antes",
  "notifications.permission_required": "Las notificaciones de escritorio no están disponibles porque no se concedió el permiso requerido.",
  "notifications.policy.accept": "Aceptar",
  "notifications.policy.accept_hint": "Mostrar en notificaciones",
  "notifications.policy.drop": "Ignorar",
  "notifications.policy.drop_hint": "Enviar al vacío, no volver a mostrar nunca",
  "notifications.policy.filter": "Filtrar",
  "notifications.policy.filter_hint": "Enviar a la bandeja de entrada de notificaciones filtradas",
  "notifications.policy.filter_limited_accounts_hint": "Limitada por los moderadores del servidor",
  "notifications.policy.filter_limited_accounts_title": "Cuentas moderadas",
  "notifications.policy.filter_new_accounts.hint": "Creada hace {days, plural, one {un día} other {# días}}",
  "notifications.policy.filter_new_accounts_title": "Nuevas cuentas",
  "notifications.policy.filter_not_followers_hint": "Incluyendo cuentas que te han estado siguiendo menos de {days, plural, one {un día} other {# días}}",
  "notifications.policy.filter_not_followers_title": "Cuentas que no te siguen",
  "notifications.policy.filter_not_following_hint": "Hasta que las aprobés manualmente",
  "notifications.policy.filter_not_following_title": "Cuentas que no seguís",
  "notifications.policy.filter_private_mentions_hint": "Filtradas, a menos que sea en respuesta a tu propia mención o si seguís al remitente",
  "notifications.policy.filter_private_mentions_title": "Menciones privadas no solicitadas",
  "notifications.policy.title": "Administrar notificaciones de…",
  "notifications_permission_banner.enable": "Habilitar notificaciones de escritorio",
  "notifications_permission_banner.how_to_control": "Para recibir notificaciones cuando Mastodon no está abierto, habilitá las notificaciones de escritorio. Podés controlar con precisión qué tipos de interacciones generan notificaciones de escritorio a través del botón {icon} de arriba, una vez que estén habilitadas.",
  "notifications_permission_banner.title": "No te pierdas nada",
  "onboarding.follows.back": "Volver",
  "onboarding.follows.empty": "Desafortunadamente, no se pueden mostrar resultados en este momento. Podés intentar usar la búsqueda o navegar por la página de exploración para encontrar cuentas a las que seguir, o intentarlo de nuevo más tarde.",
  "onboarding.follows.next": "Siguiente: Configurá tu perfil",
  "onboarding.follows.search": "Buscar",
  "onboarding.follows.title": "Para comenzar, empezá a seguir cuentas",
  "onboarding.profile.discoverable": "Hacer que mi perfil sea detectable",
  "onboarding.profile.discoverable_hint": "Cuando optás por ser detectable en Mastodon, tus mensajes pueden aparecer en los resultados de búsqueda y de tendencia, y tu perfil puede ser sugerido a personas con intereses similares a los tuyos.",
  "onboarding.profile.display_name": "Nombre para mostrar",
  "onboarding.profile.display_name_hint": "Tu nombre completo o tu pseudónimo…",
  "onboarding.profile.finish": "Finalizar",
  "onboarding.profile.note": "Biografía",
  "onboarding.profile.note_hint": "Podés @mencionar otras cuentas o usar #etiquetas…",
  "onboarding.profile.title": "Configuración del perfil",
  "onboarding.profile.upload_avatar": "Subir avatar",
  "onboarding.profile.upload_header": "Subir cabecera",
  "password_confirmation.exceeds_maxlength": "La confirmación de contraseña excede la longitud máxima de la contraseña",
  "password_confirmation.mismatching": "La confirmación de contraseña no coincide",
  "picture_in_picture.restore": "Restaurar",
  "poll.closed": "Cerrada",
  "poll.refresh": "Refrescar",
  "poll.reveal": "Ver resultados",
  "poll.total_people": "{count, plural, one {# persona} other {# personas}}",
  "poll.total_votes": "{count, plural, one {voto} other {votos}}",
  "poll.vote": "Votar",
  "poll.voted": "Votaste esta opción",
  "poll.votes": "{votes, plural, one {voto} other {votos}}",
  "poll_button.add_poll": "Agregar encuesta",
  "poll_button.remove_poll": "Quitar encuesta",
  "privacy.change": "Configurar privacidad del mensaje",
  "privacy.direct.long": "Todas las cuentas mencionadas en el mensaje",
  "privacy.direct.short": "Mención privada",
  "privacy.private.long": "Solo tus seguidores",
  "privacy.private.short": "Seguidores",
  "privacy.public.long": "Cualquier persona dentro y fuera de Mastodon",
  "privacy.public.short": "Público",
  "privacy.quote.anyone": "{visibility}, citas permitidas",
  "privacy.quote.disabled": "{visibility}, citas deshabilitadas",
  "privacy.quote.limited": "{visibility}, citas limitadas",
  "privacy.unlisted.additional": "Esto se comporta exactamente igual que con la configuración de privacidad de mensaje «Público», excepto que el mensaje no aparecerá en las líneas temporales en vivo, ni en las etiquetas, ni en la línea temporal «Explorá», ni en la búsqueda de Mastodon; incluso si optaste por hacer tu cuenta visible.",
  "privacy.unlisted.long": "Oculto de los resultados de búsqueda, tendencias y líneas temporales públicas de Mastodon",
  "privacy.unlisted.short": "Público pero silencioso",
  "privacy_policy.last_updated": "Última actualización: {date}",
  "privacy_policy.title": "Política de privacidad",
  "quote_error.edit": "Las citas no se pueden agregar al editar un mensaje.",
  "quote_error.poll": "No se permite citar encuestas.",
  "quote_error.private_mentions": "No se permite citar con menciones directas.",
  "quote_error.quote": "Solo se permite una cita a la vez.",
  "quote_error.unauthorized": "No tenés autorización para citar este mensaje.",
  "quote_error.upload": "No se permite citar con archivos multimedia.",
  "recommended": "Opción recomendada",
  "refresh": "Refrescar",
  "regeneration_indicator.please_stand_by": "Esperá, por favor.",
  "regeneration_indicator.preparing_your_home_feed": "Preparando tu línea temporal principal…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural,one {hace # día} other {hace # días}}",
  "relative_time.full.hours": "{number, plural,one {hace # hora} other {hace # horas}}",
  "relative_time.full.just_now": "recién",
  "relative_time.full.minutes": "{number, plural,one {hace # minuto} other {hace # minutos}}",
  "relative_time.full.seconds": "{number, plural,one {hace # segundo} other {hace # segundos}}",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "ahora",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "hoy",
  "remove_quote_hint.button_label": "Entendido",
  "remove_quote_hint.message": "Podés hacerlo desde el menú de opciones {icon}.",
  "remove_quote_hint.title": "¿Querés eliminar tu mensaje citado?",
  "reply_indicator.attachments": "{count, plural,one {# adjunto} other {# adjuntos}}",
  "reply_indicator.cancel": "Cancelar",
  "reply_indicator.poll": "Encuesta",
  "report.block": "Bloquear",
  "report.block_explanation": "No verás sus mensajes. No podrán ver tus mensajes ni seguirte. Se van a dar cuentra de que están bloqueados.",
  "report.categories.legal": "Legales",
  "report.categories.other": "Otra",
  "report.categories.spam": "Spam",
  "report.categories.violation": "El contenido viola una o más reglas del servidor",
  "report.category.subtitle": "Elegí la mejor coincidencia",
  "report.category.title": "Contanos lo que pasa con este {type}",
  "report.category.title_account": "perfil",
  "report.category.title_status": "mensaje",
  "report.close": "Listo",
  "report.collection_comment": "¿Por qué querés denunciar esta colección?",
  "report.comment.title": "¿Hay algo más que creés que deberíamos saber?",
  "report.forward": "Reenviar a {target}",
  "report.forward_hint": "La cuenta es de otro servidor. ¿Querés enviar una copia anonimizada del informe también ahí?",
  "report.mute": "Silenciar",
  "report.mute_explanation": "No verás sus mensajes. Todavía pueden seguirte y ver tus mensajes y no sabrán que están silenciados.",
  "report.next": "Siguiente",
  "report.placeholder": "Comentarios adicionales",
  "report.reasons.dislike": "No me gusta",
  "report.reasons.dislike_description": "No es algo que querés ver",
  "report.reasons.legal": "Es ilegal",
  "report.reasons.legal_description": "Creés que viola la ley de tu país o el país del servidor",
  "report.reasons.other": "Es otra cosa",
  "report.reasons.other_description": "El problema no aplica en otras categorías",
  "report.reasons.spam": "Es spam",
  "report.reasons.spam_description": "Enlaces maliciosos, interacciones falsas o respuestas repetitivas",
  "report.reasons.violation": "Viola las reglas del servidor",
  "report.reasons.violation_description": "Sos consciente de que infringe normas específicas",
  "report.rules.subtitle": "Seleccioná todo lo que corresponda",
  "report.rules.title": "¿Qué reglas se están violando?",
  "report.statuses.subtitle": "Seleccioná todo lo que corresponda",
  "report.statuses.title": "¿Hay algún mensaje que respalde esta denuncia?",
  "report.submission_error": "No se pudo enviar la denuncia",
  "report.submission_error_details": "Por favor, revisá tu conexión a Internet e intentá de nuevo más tarde.",
  "report.submit": "Enviar",
  "report.target": "Denunciando a {target}",
  "report.thanks.take_action": "Acá están tus opciones para controlar lo que ves en Mastodon:",
  "report.thanks.take_action_actionable": "Mientras revisamos esto, podés tomar medidas contra @{name}:",
  "report.thanks.title": "¿No querés ver esto?",
  "report.thanks.title_actionable": "Gracias por tu denuncia, vamos a revisarla.",
  "report.unfollow": "Dejar de seguir a @{name}",
  "report.unfollow_explanation": "Estás siguiendo a esta cuenta. Para no ver sus mensajes en tu línea temporal principal, dejá de seguirla.",
  "report_notification.attached_statuses": "{count, plural, one {{count} mensaje adjunto} other {{count} mensajes adjuntos}}",
  "report_notification.categories.legal": "Legal",
  "report_notification.categories.legal_sentence": "contenido ilegal",
  "report_notification.categories.other": "Otros",
  "report_notification.categories.other_sentence": "[otras categorías]",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Violación de regla",
  "report_notification.categories.violation_sentence": "violación de regla",
  "report_notification.open": "Abrir denuncia",
  "search.clear": "Limpiar búsqueda",
  "search.no_recent_searches": "Sin búsquedas recientes",
  "search.placeholder": "Buscar",
  "search.quick_action.account_search": "Perfiles que coinciden con {x}",
  "search.quick_action.go_to_account": "Ir al perfil de {x}",
  "search.quick_action.go_to_hashtag": "Ir a la etiqueta {x}",
  "search.quick_action.open_url": "Abrir enlace en Mastodon",
  "search.quick_action.status_search": "Mensajes que coinciden con {x}",
  "search.search_or_paste": "Buscar o pegar dirección web",
  "search_popout.full_text_search_disabled_message": "No disponible en {domain}.",
  "search_popout.full_text_search_logged_out_message": "Solo disponible al iniciar sesión.",
  "search_popout.language_code": "Código ISO de idioma",
  "search_popout.options": "Opciones de búsqueda",
  "search_popout.quick_actions": "Acciones rápidas",
  "search_popout.recent": "Búsquedas recientes",
  "search_popout.specific_date": "fecha específica",
  "search_popout.user": "usuario",
  "search_results.accounts": "Perfiles",
  "search_results.all": "Todos",
  "search_results.hashtags": "Etiquetas",
  "search_results.no_results": "Sin resultados.",
  "search_results.no_search_yet": "Intentá buscar publicaciones, perfiles o etiquetas.",
  "search_results.see_all": "Ver todo",
  "search_results.statuses": "Mensajes",
  "search_results.title": "Búsqueda de «{q}»",
  "server_banner.about_active_users": "Personas usando este servidor durante los últimos 30 días (Usuarios Activos Mensuales)",
  "server_banner.active_users": "usuarios activos",
  "server_banner.administered_by": "Administrado por:",
  "server_banner.is_one_of_many": "{domain} es uno de los muchos servidores de Mastodon independientes que podés usar para participar en el Fediverso.",
  "server_banner.more_about_this_server": "Más acerca de este servidor",
  "server_banner.server_stats": "Estadísticas del servidor:",
  "sign_in_banner.create_account": "Crear cuenta",
  "sign_in_banner.follow_anyone": "Seguí a cualquiera cuenta a través del Fediverso y leé todo en orden cronológico. Nada de algoritmos, publicidad o titulares engañosos.",
  "sign_in_banner.mastodon_is": "Mastodon es la mejor manera de mantenerse al día sobre lo que está sucediendo.",
  "sign_in_banner.sign_in": "Iniciar sesión",
  "sign_in_banner.sso_redirect": "Iniciá sesión o registrate",
  "skip_links.hotkey": "<span>Atajo</span> {hotkey}",
  "skip_links.skip_to_content": "Ir al contenido principal",
  "skip_links.skip_to_navigation": "Ir a la navegación principal",
  "status.admin_account": "Abrir interface de moderación para @{name}",
  "status.admin_domain": "Abrir interface de moderación para {domain}",
  "status.admin_status": "Abrir este mensaje en la interface de moderación",
  "status.all_disabled": "Las adhesiones y citas están deshabilitadas",
  "status.block": "Bloquear a @{name}",
  "status.bookmark": "Marcar",
  "status.cancel_reblog_private": "Quitar adhesión",
  "status.cannot_quote": "No te es permitido citar este mensaje",
  "status.cannot_reblog": "No se puede adherir a este mensaje",
  "status.contains_quote": "Contiene cita",
  "status.context.loading": "Cargando más respuestas",
  "status.context.loading_error": "No se pudieron cargar nuevas respuestas",
  "status.context.loading_success": "Se cargaron nuevas respuestas",
  "status.context.more_replies_found": "Se encontraron más respuestas",
  "status.context.retry": "Reintentar",
  "status.context.show": "Mostrar",
  "status.continued_thread": "Continuación de hilo",
  "status.copy": "Copiar enlace al mensaje",
  "status.delete": "Eliminar",
  "status.delete.success": "Mensaje eliminado",
  "status.detailed_status": "Vista de conversación detallada",
  "status.direct": "Mención privada a @{name}",
  "status.direct_indicator": "Mención privada",
  "status.edit": "Editar",
  "status.edited": "Última edición: {date}",
  "status.edited_x_times": "Editado {count, plural, one {{count} vez} other {{count} veces}}",
  "status.embed": "Obtener código para insertar",
  "status.favourite": "Marcar como favorito",
  "status.favourites_count": "{count, plural,one {{counter} favorito}other {{counter} favoritos}}",
  "status.filter": "Filtrar este mensaje",
  "status.history.created": "Creado por {name}, {date}",
  "status.history.edited": "Editado por {name}, {date}",
  "status.load_more": "Cargar más",
  "status.media.open": "Clic para abrir",
  "status.media.show": "Clic para mostrar",
  "status.media_hidden": "Medios ocultos",
  "status.mention": "Mencionar a @{name}",
  "status.more": "Más",
  "status.mute": "Silenciar a @{name}",
  "status.mute_conversation": "Silenciar conversación",
  "status.open": "Expandir este mensaje",
  "status.pin": "Fijar en el perfil",
  "status.quote": "Citar",
  "status.quote.cancel": "Cancelar cita",
  "status.quote_error.blocked_account_hint.title": "Este mensaje está oculto porque bloqueaste a @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Este mensaje está oculto porque bloqueaste {domain}.",
  "status.quote_error.filtered": "Oculto debido a uno de tus filtros",
  "status.quote_error.limited_account_hint.action": "Mostrar de todos modos",
  "status.quote_error.limited_account_hint.title": "Esta cuenta fue ocultada por los moderadores de {domain}.",
  "status.quote_error.muted_account_hint.title": "Este mensaje está oculto porque silenciaste a @{name}.",
  "status.quote_error.not_available": "Mensaje no disponible",
  "status.quote_error.pending_approval": "Mensaje pendiente",
  "status.quote_error.pending_approval_popout.body": "En Mastodon, podés controlar si alguien te puede citar. Este mensaje está pendiente hasta obtener la aprobación del autor original.",
  "status.quote_error.revoked": "Mensaje eliminado por el autor",
  "status.quote_followers_only": "Solo los seguidores pueden citar este mensaje",
  "status.quote_manual_review": "El autor revisará manualmente",
  "status.quote_noun": "Cita",
  "status.quote_policy_change": "Cambiá quién puede citar",
  "status.quote_post_author": "Se citó un mensaje de @{name}",
  "status.quote_private": "No se pueden citar los mensajes privados",
  "status.quotes.empty": "Todavía nadie citó este mensaje. Cuando alguien lo haga, se mostrará acá.",
  "status.quotes.local_other_disclaimer": "Las citas rechazadas por el autor no serán mostradas.",
  "status.quotes.remote_other_disclaimer": "Solo las citas de {domain} están garantizadas de ser mostradas acá. Las citas rechazadas por el autor no serán mostradas.",
  "status.quotes_count": "{count, plural,one {{counter} cita} other {{counter} citas}}",
  "status.read_more": "Leé más",
  "status.reblog": "Adherir",
  "status.reblog_or_quote": "Adherir o citar",
  "status.reblog_private": "Compartir de nuevo con tus seguidores",
  "status.reblogged_by": "{name} adhirió",
  "status.reblogs.empty": "Todavía nadie adhirió a este mensaje. Cuando alguien lo haga, se mostrará acá.",
  "status.reblogs_count": "{count, plural,one {{counter} adhesión} other {{counter} adhesiones}}",
  "status.redraft": "Eliminar mensaje original y editarlo",
  "status.remove_bookmark": "Quitar marcador",
  "status.remove_favourite": "Quitar de favoritos",
  "status.remove_quote": "Quitar",
  "status.replied_in_thread": "Respuesta en hilo",
  "status.replied_to": "Respondió a {name}",
  "status.reply": "Responder",
  "status.replyAll": "Responder al hilo",
  "status.report": "Denunciar a @{name}",
  "status.request_quote": "Solicitud para citar",
  "status.revoke_quote": "Eliminar mi mensaje de la cita de @{name}",
  "status.sensitive_warning": "Contenido sensible",
  "status.share": "Compartir",
  "status.show_less_all": "Mostrar menos para todo",
  "status.show_more_all": "Mostrar más para todo",
  "status.show_original": "Mostrar original",
  "status.title.with_attachments": "{user} envió {attachmentCount, plural, one {un adjunto} other {{attachmentCount} adjuntos}}",
  "status.translate": "Traducir",
  "status.translated_from_with": "Traducido desde el {lang} vía {provider}",
  "status.uncached_media_warning": "Previsualización no disponible",
  "status.unmute_conversation": "Dejar de silenciar conversación",
  "status.unpin": "Dejar de fijar",
  "subscribed_languages.lead": "Después del cambio, solo los mensajes en los idiomas seleccionados aparecerán en tu línea temporal Principal y en las líneas de tiempo de lista. No seleccionés ningún idioma para poder recibir mensajes en todos los idiomas.",
  "subscribed_languages.save": "Guardar cambios",
  "subscribed_languages.target": "Cambiar idiomas suscritos para {target}",
  "tabs_bar.home": "Principal",
  "tabs_bar.menu": "Menú",
  "tabs_bar.notifications": "Notificaciones",
  "tabs_bar.publish": "Nuevo mensaje",
  "tabs_bar.search": "Buscar",
  "tag.remove": "Quitar",
  "terms_of_service.effective_as_of": "Efectivo a partir de {date}",
  "terms_of_service.title": "Términos del servicio",
  "terms_of_service.upcoming_changes_on": "Próximos cambios el {date}",
  "time_remaining.days": "{number, plural,one {queda # día} other {quedan # días}}",
  "time_remaining.hours": "{number, plural,one {queda # hora} other {quedan # horas}}",
  "time_remaining.minutes": "{number, plural,one {queda # minuto} other {quedan # minutos}}",
  "time_remaining.moments": "Momentos restantes",
  "time_remaining.seconds": "{number, plural,one {queda # segundo} other {quedan # segundos}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persona} other {{counter} personas}} en {days, plural, one {el pasado día} other {los pasados {days} días}}",
  "trends.trending_now": "Tendencia ahora",
  "ui.beforeunload": "Tu borrador se perderá si abandonás Mastodon.",
  "units.short.billion": "{count}MM",
  "units.short.million": "{count} M",
  "units.short.thousand": "{count} mil",
  "upload_area.title": "Para subir, arrastrá y soltá",
  "upload_button.label": "Agregá imágenes, o un archivo de audio o video",
  "upload_error.limit": "Se excedió el límite de subida de archivos.",
  "upload_error.poll": "No se permite la subida de archivos en encuestas.",
  "upload_error.quote": "No se permite subir archivos con citas.",
  "upload_form.drag_and_drop.instructions": "Para recoger un archivo multimedia, pulsá la barra espaciadora o la tecla Enter. Mientras arrastrás, usá las teclas de flecha para mover el archivo multimedia en cualquier dirección. Volvé a pulsar la barra espaciadora o la tecla Enter para soltar el archivo multimedia en su nueva posición, o pulsá la tecla Escape para cancelar.",
  "upload_form.drag_and_drop.on_drag_cancel": "Se canceló el arrastre. Se eliminó el archivo adjunto {item}.",
  "upload_form.drag_and_drop.on_drag_end": "El archivo adjunto {item} fue soltado.",
  "upload_form.drag_and_drop.on_drag_over": "El archivo adjunto {item} fue movido.",
  "upload_form.drag_and_drop.on_drag_start": "Se ha recogido el archivo adjunto {item}.",
  "upload_form.edit": "Editar",
  "upload_progress.label": "Subiendo...",
  "upload_progress.processing": "Procesando…",
  "username.taken": "Ese nombre de usuario está ocupado. Probá con otro",
  "video.close": "Cerrar video",
  "video.download": "Descargar archivo",
  "video.exit_fullscreen": "Salir de la pantalla completa",
  "video.expand": "Expandir video",
  "video.fullscreen": "Pantalla completa",
  "video.hide": "Ocultar video",
  "video.mute": "Silenciar",
  "video.pause": "Pausar",
  "video.play": "Reproducir",
  "video.skip_backward": "Saltar atrás",
  "video.skip_forward": "Adelantar",
  "video.unmute": "Quitar silenciado",
  "video.volume_down": "Bajar volumen",
  "video.volume_up": "Subir volumen",
  "visibility_modal.button_title": "Establecer visibilidad",
  "visibility_modal.direct_quote_warning.text": "Si guardás la configuración actual, la cita insertada se convertirá en un enlace.",
  "visibility_modal.direct_quote_warning.title": "Las citas no pueden ser insertadas en menciones privadas",
  "visibility_modal.header": "Visibilidad e interacción",
  "visibility_modal.helper.direct_quoting": "Las menciones privadas redactadas en Mastodon no pueden ser citadas por otras cuentas.",
  "visibility_modal.helper.privacy_editing": "La visibilidad no se puede cambiar después de que se haya enviado un mensaje.",
  "visibility_modal.helper.privacy_private_self_quote": "Las citas propias de mensajes privados no pueden hacerse públicas.",
  "visibility_modal.helper.private_quoting": "Los mensajes solo para seguidores redactados en Mastodon no pueden ser citados por otras cuentas.",
  "visibility_modal.helper.unlisted_quoting": "Cuando otras cuentas te citen, sus publicaciones también se ocultarán de las líneas temporales de tendencias.",
  "visibility_modal.instructions": "Controlá quién puede interactuar con este mensaje. También podés aplicar los ajustes para todos los mensajes futuros accediendo a <link>«Configuración» > «Configuración predeterminada de mensajes»</link>.",
  "visibility_modal.privacy_label": "Visibilidad",
  "visibility_modal.quote_followers": "Solo seguidores",
  "visibility_modal.quote_label": "Quién puede citar",
  "visibility_modal.quote_nobody": "Solo yo",
  "visibility_modal.quote_public": "Cualquier cuenta",
  "visibility_modal.save": "Guardar"
}
